<template>
  <div>
    <el-container>
      <el-header>
        <head_page :head_page_type="false" ref="head_page"></head_page>
      </el-header>
      <el-main
        v-loading="loading"
        v-bind:element-loading-text="$t('message.Desperately_loading')"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <div id="choose_city">
          <head_menu
            :has-back="true"
            @go-back-click="goBack"
            :has-next="true"
            @go-next-click="goNext"
          >
            <template #title>
              <div
                style="
                  text-align: center;
                  background-color: #f0f0ee;
                  color: #53adbc;
                  padding: 5px;
                  font-size: 20px;
                "
              >
                {{ chosen_city_shown }}
              </div>
            </template>
          </head_menu>
          <el-container
            class="hidden-sm-and-down"
            style="background-color: #f7f7f6"
          >
            <div class="level2_div_map">
              <el-aside style="width: 530px; overflow-x: hidden; margin: 5px">
                <br />
                <div
                  style="
                    text-align: center;
                    font-size: 16px;
                    background-color: white;
                    padding: 20px;
                  "
                >
                  <el-row :gutter="2">
                    <el-col :span="12">
                      <div>
                        <strong>{{
                          $t("message.Recommended_Bus_Lines")
                        }}</strong>
                        <el-popover
                          placement="top-start"
                          width="300"
                          trigger="hover"
                          :content="$t('message.Recommended_Bus_Lines')"
                        >
                          <div>
                            <span>{{
                              $t("message.Recommended_Bus_Lines_Text1")
                            }}</span>
                            <br />
                            <span>{{
                              $t("message.Recommended_Bus_Lines_Text2")
                            }}</span>
                            <br />
                            <span>{{
                              $t("message.Recommended_Bus_Lines_Text3")
                            }}</span>
                            <br />
                            <span>{{
                              $t("message.Recommended_Bus_Lines_Text4")
                            }}</span>
                            <br />
                            <span>{{
                              $t("message.Recommended_Bus_Lines_Text5")
                            }}</span>
                            <br />
                            <span>{{
                              $t("message.Recommended_Bus_Lines_Text6")
                            }}</span>
                            <br />
                            <span>{{
                              $t("message.Recommended_Bus_Lines_Text7")
                            }}</span>
                            <br />
                            <span>{{
                              $t("message.Recommended_Bus_Lines_Text8")
                            }}</span>
                            <br />
                            <span>{{
                              $t("message.Recommended_Bus_Lines_Text9")
                            }}</span>
                            <br />
                            <span>{{
                              $t("message.Recommended_Bus_Lines_Text10")
                            }}</span>
                            <br />
                            <span>{{
                              $t("message.Recommended_Bus_Lines_Text11")
                            }}</span>
                            <br />
                            <span>{{
                              $t("message.Recommended_Bus_Lines_Text12")
                            }}</span>
                            <br />
                            <span>{{
                              $t("message.Recommended_Bus_Lines_Text13")
                            }}</span>
                            <br />
                          </div>
                          <el-button
                            icon="el-icon-info"
                            circle
                            slot="reference"
                            style="border: 0px"
                          ></el-button>
                        </el-popover>
                        <div>
                          <el-button
                            @click="refreshPanelButton"
                            style="background-color: Swhite"
                            >{{ $t("message.Refresh") }}</el-button
                          >
                        </div>
                      </div>
                    </el-col>
                    <el-col :span="12" style="margin-top: 3px;">
                    <strong style="font-size:12px">{{ $t("message.Index_Performance") }}</strong><strong>{{this.radialBarData}}</strong>
                    <v-gauge
                      :value="radialBarData"
                      :options="radialBarOptions"
                      height ="100px"
                      width="150px"
                      :minValue="50"
                      :maxValue="150"
                    />
                    </el-col>
                  </el-row>
                  <el-row>
                    <p style="font-size:12px; text-align: left;font-weight: bolder; margin-left:20px; position: absolute">{{ $t("message.Index_Distribution") }}</p>
                    <apexchart class="heatmapchart"
                      ref="indexchart"
                      type="heatmap"
                      height="90"
                      width="300"
                      :options="indexChartOptions"
                      :series="indexChartData"
                    ></apexchart>
                  </el-row>
                  
                  <el-row style="margin-top: 20px">
                    <p style="font-size:12px; text-align: left;font-weight: bolder; margin-left:20px; position: absolute">{{ $t("message.Grade_Distribution") }}</p>
                    <apexchart class="heatmapchart"
                      ref="rankchart"
                      type="heatmap"
                      height="90"
                      width="300"
                      :options="rankChartOptions"
                      :series="rankChartData"
                    ></apexchart>
                  </el-row>
                  
                </div>

                <br />
                <div>
                  <el-select
                    v-model="multiple.selectedList"
                    multiple
                    collapse-tags
                    style="width: 360px"
                    placeholder="Please Select ..."
                    filterable
                  >
                    <el-option
                      v-for="(item,idx) in multiple.originOptions"
                      :key="item.id"
                      :label='$i18n.locale == "en" ?
                          item.name.replace("Line ", "").replace("路", "").replace("高峰快巴", "Peak Express ").replace("高峰专线", "Peak Line ")
                          : item.name.replace("Line ", "").replace("路", "")'
                      :value="item.id"
                      >
                      <span>
                      {{ $i18n.locale == 'en' ?
                          item.name.replace("Line ", "").replace("路", "").replace("高峰快巴", "Peak Express ").replace("高峰专线", "Peak Line ")
                          : item.name.replace("Line ", "").replace("路", "") }}
                      </span>
                      <span style="float:right; margin-right: 20px">
                        {{idx==0 ? "index: " + item.rate : item.rate}}
                      </span>
                    </el-option>
                  </el-select>
                  <el-button size="mini" style="margin-left: 10px" @click="selectAllLines" v-if="bu == 'DDV'">
                    {{ $i18n.locale == 'en' ? 'Select All' : '全选' }}
                  </el-button>
                </div>
                <div
                  style="
                    width: 530px;
                    height: 1079px;
                    background-color: white;
                    margin-top: 20px;
                  "
                >
                  <el-table
                    ref="multipleTable"
                    :data="selectedOptions"
                    tooltip-effect="dark"
                    style="width: 100%"
                    :show-headser="false"
                    @selection-change="handleSelectionChange"
                    :header-row-style="{
                      color: '#254A6E',
                      'font-weight': 'bold',
                    }"
                    :row-class-name="tableRowClassName"
                  >
                    <el-table-column
                      type="selection"
                      width="40"
                    ></el-table-column>

                    <el-table-column :label="$t('message.Line')" width="80">
                      <template slot-scope="scope" style="text-align: center; word-break: break-word">
                        <el-tooltip class="item" effect="dark" :content="rowInventoryTextByHub(scope.row)" placement="top-start">
                          <div>
                          <i class="el-icon-warning" v-if="isEmpty(scope.row)" style="color: red; margin-right:-4px; vertical-align: text-bottom; font-size: 18px;" />
                          <i class="el-icon-star-on" v-if="isPriority(scope.row)" style="color: gold; margin-right:-4px; vertical-align: text-bottom; font-size: 18px;" />
                          <i class="el-icon-star-on" v-if="isWarning(scope.row)" style="color: red; margin-right:-4px; vertical-align: text-bottom; font-size: 18px;" />
                          <span v-if="!isPriority(scope.row) && !isWarning(scope.row) && !isEmpty(scope.row)" style="margin-right: 20px;"> </span>
                          
                        {{ $i18n.locale == 'en' ? 
                          scope.row.name.replace("Line ", "").replace("路", "").replace("高峰快巴", "Peak Express ").replace("高峰专线", "Peak Line ")
                          : scope.row.name.replace("Line ", "").replace("路", "") }}
                          </div>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                    <el-table-column
                      :label="$t('message.Related_Location_Number')"
                      width="75"
                      v-if="this.dataInfo.poi_ba_value_selection_list.length"
                    >
                      <template slot-scope="scope" style="text-align: center">{{
                        scope.row.related_poi_nb
                      }}</template>
                    </el-table-column>
                    <el-table-column
                      :label="$t('message.vendor')"
                      width="100"
                      v-if = "chosen_city=='Shanghai'"
                    >
                      <template slot-scope="scope" style="text-align: center">{{
                        scope.row.vendor_name
                      }}</template>
                    </el-table-column>
                    <el-table-column width="70">
                      <template slot="header" slot-scope="scope">
                        {{ $t("message.index") }}
                        <el-popover placement="top-start" trigger="hover">
                          <pre v-if="$i18n.locale == 'en'">
Audience based campaign :

Result will automatically provide bus lines by their best performance index according to chosen criterias

Note : 
- target profile & audience interests can be combined together
- Interst is unique choice

                    </pre
                          >
                          <pre v-if="$i18n.locale == 'cn'">
基于受众的广告投放：

结果将根据选择的标准以最佳性能指标自动提供巴士线路

注意 ：
-目标资料和受众兴趣可以结合在一起
-兴趣是唯一的选择
                    </pre
                          >
                          <el-button
                            icon="el-icon-info"
                            circle
                            slot="reference"
                            style="border: 0px; background-color: #f6f6f6"
                          ></el-button>
                        </el-popover>
                      </template>
                      <template slot-scope="scope" style="text-align: center">{{
                        scope.row.rate
                      }}</template>
                    </el-table-column>
                    <el-table-column :label="$t('message.rank')" width="55">
                      <template slot-scope="scope" style="text-align: center">{{
                        scope.row.rank_tag
                      }}</template>
                    </el-table-column>
                    <el-table-column>
                      <template slot="header">
                        <span>{{ $t("message.operation") }}</span>
                        <div style="display: inline-block">
                          <span style="margin-left: 1em"
                            >{{ $t("message.Bus_Body") }}:</span
                          >
                          <input
                            style="
                              margin-left: 1em;
                              display: inline;
                              width: 1.5em;
                            "
                            @change="busbodyGlobalChange"
                            v-model="busbodyGlobal"
                          />
                        </div>
                      </template>
                      <template slot-scope="scope">
                        <el-row>
                          <el-col :span="12">
                            <el-popover placement="right" trigger="click">
                              <div>
                                <el-row>
                                  <el-col :span="8"
                                    >{{ $t("message.Bus_Body") }}:</el-col
                                  >
                                  <el-col :span="16">
                                    <el-input
                                      size="mini"
                                      v-model="busbody[scope.$index]"
                                    ></el-input>
                                  </el-col>
                                </el-row>
                              </div>
                              <div>
                                <el-row>
                                  <el-col :span="8"
                                    >{{ $t("message.Format") }}:</el-col
                                  >
                                  <el-col :span="16">
                                    <el-select
                                      v-model="media_formats[scope.$index]"
                                      size="mini"
                                    >
                                    <!--
                                    -->
                                      <el-option
                                        v-if="$i18n.locale == 'en'"
                                        v-for="item in scope.row.available_formats.length > 0 ? 
                                            media_format_options.filter(o => scope.row.available_formats.includes(o.value)) : media_format_options"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                      >
                                        <span>{{ item.label }}</span>
                                      </el-option>

                                      <el-option
                                        v-if="$i18n.locale == 'cn'"
                                        v-for="item in scope.row.available_formats.length > 0 ? 
                                            media_format_options.filter(o => scope.row.available_formats.includes(o.value)) : media_format_options"
                                        :key="item.value"
                                        :label="item.label_cn"
                                        :value="item.value"
                                      >
                                        <span>{{ item.label_cn }}</span>
                                      </el-option>
                                    </el-select>
                                  </el-col>
                                </el-row>
                              </div>

                              <el-button
                                slot="reference"
                                icon="el-icon-more"
                                type="info"
                                plain
                              ></el-button>
                            </el-popover>
                            <div></div>
                          </el-col>
                          <el-col :span="12">
                            <el-button
                              type="info"
                              plain
                              @click.native.prevent="
                                deleteRow(scope.$index, selectedOptions)
                              "
                              icon="el-icon-delete"
                            ></el-button>
                          </el-col>
                        </el-row>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </el-aside>
            </div>
            <el-container>
              <div
                class="level2_div_map"
                id="top_board"
                style="background-color: white; border: 1px solid #e9e9ea;"
              >

                <el-row type="flex" justify="space-between">
                  <el-col
                    :span="10"
                    style="
                      border-right: 1px solid #ced4da;
                      border-top: 1px solid #ced4da;
                      border-radius: 0px;
                      padding-bottom: 20px;
                    "
                  >
                    <div style="background-color: white">
                      <el-row style="margin-top: 25px">
                        <span style="font-size: 18px; color: #254a6e; font-weight: 600">
                          {{ $t("message.Campaign_Starting_Date") }}
                          {{ this.dataInfo.date.split("T")[0] }}
                        </span>
                      </el-row>
                      <el-row :gutter="20" style="margin-top: 25px">
                        <el-col :span="8">
                          <p class="p-title-1">
                            {{ $t("message.Number_of_Bus_Lines") }}
                          </p>
                        </el-col>
                        <el-col :span="8">
                          <p class="p-title-1">
                            {{ $t("message.Number_of_Bus_Body") }}
                          </p>
                        </el-col>
                        <el-col :span="8">
                          <p class="p-title-1">{{ $t("message.Duration(Months)") }}</p>
                        </el-col>
                      </el-row>
                      <el-row :gutter="20" >
                        <el-col :span="8">
                          <div class="div_number">
                            <p class="p-content-1">{{ tableData[0].value }}</p>
                          </div>
                        </el-col>
                        <el-col :span="8">
                          <div>
                            <p class="p-content-1">{{ tableData[1].value }}</p>
                          </div>
                        </el-col>
                        <el-col :span="8">
                          <div>
                            <p class="p-content-1">{{ tableData[2].value }}</p>
                          </div>
                        </el-col>
                      </el-row>
                      <el-row :gutter="20" style="margin-top: 25px">
                        <el-col :span="l1">
                          <p class="p-title-2">
                            {{ $t("message.Viewed_Impression") }}
                            <el-popover
                              placement="top-start"
                              width="300"
                              trigger="hover"
                              :content="$t('message.textViewedImpressions')"
                            >
                              <el-button
                                icon="el-icon-info"
                                circle
                                slot="reference"
                                style="border: 0px"
                              ></el-button>
                            </el-popover>
                          </p>
                        </el-col>
                        <el-col :span="l2" v-if="ifShowViewed">
                          <p class="p-title-2">
                            {{ $t("message.Viewed_Impression(Audience)") }}
                          </p>
                        </el-col>
                      </el-row>
                      <el-row :gutter="20">
                        <el-col :span="l1">
                          <div class="div_number">
                            <p class="p-content-2">
                              {{ tableData[4].value }}
                            </p>
                          </div>
                        </el-col>
                        <el-col :span="l1">
                          <div>
                            <p class="p-content-2" v-if="ifShowViewed">
                              {{ tableData[5].value }}
                            </p>
                          </div>
                        </el-col>
                      </el-row>
                      <!-- <el-row :gutter="20" style="margin-top: 25px" v-if="false"> -->
                      <el-row :gutter="20" style="margin-top: 25px" v-if="chosen_city=='Nanjing' || chosen_city=='Chongqing'">
                        <el-col :span="8">
                          <p class="p-title-2">
                            {{ $t("message.Distinct_Audience") }}
                            <el-popover
                              placement="top-start"
                              width="300"
                              trigger="hover"
                              :content="$t('message.textCoverageAudience')"
                            >
                              <el-button
                                icon="el-icon-info"
                                circle
                                slot="reference"
                                style="border: 0px"
                              ></el-button>
                            </el-popover>
                          </p>
                        </el-col>
                        <el-col :span="8">
                          <p class="p-title-2">
                            {{ $t("message.One_Month_Freq") }}
                            <el-popover
                              placement="top-start"
                              width="300"
                              trigger="hover"
                              :content="$t('message.textOneMonthFreq')"
                            >
                              <el-button
                                icon="el-icon-info"
                                circle
                                slot="reference"
                                style="border: 0px"
                              ></el-button>
                            </el-popover>
                          </p>
                        </el-col>
                        <el-col :span="8">
                          <p class="p-title-2">
                            {{ $t("message.Covergae_Percentage") }}
                            <el-popover
                              placement="top-start"
                              width="300"
                              trigger="hover"
                              :content="coveragePercentageTooltip"
                            >
                              <el-button
                                icon="el-icon-info"
                                circle
                                slot="reference"
                                style="border: 0px"
                              ></el-button>
                            </el-popover>
                          </p>
                        </el-col>
                      </el-row>
                      <!-- <el-row :gutter="20" v-if="false"> -->
                      <el-row :gutter="20" v-if="chosen_city=='Nanjing'|| chosen_city=='Chongqing'">
                        <el-col :span="8">
                          <div class="div_number">
                            <p class="p-content-2">
                              {{ tableData[7].value }}
                            </p>
                          </div>
                        </el-col>
                        <el-col :span="8">
                          <div>
                            <p class="p-content-2">
                              {{ tableData[8].value }}
                            </p>
                          </div>
                        </el-col>
                        <el-col :span="8">
                          <div>
                            <p class="p-content-2">
                              {{ tableData[9].value + ' %' }}
                            </p>
                          </div>
                        </el-col>
                      </el-row>
                    </div>
                  </el-col>
                  <el-col :span="14" style="border-top: 1px solid #ced4da; padding-bottom: 20px">
                    <el-row>
                      <el-col :span="24">
                        <el-row style="margin-top: 25px">
                          <el-col :span="12">
                            <p class="p-title-1">{{ $t("message.Rate_Card_Media_Cost") }}</p>
                          </el-col>
                          <el-col :span="12">
                            <p class="p-title-1">{{ $t("message.Rate_Card_Production_Cost") }}</p>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="12">
                            <p class="p-content-1">{{ media_cost }}</p>
                          </el-col>
                          <el-col :span="12">
                            <p class="p-content-1">{{ production_cost  }}</p>
                          </el-col>
                        </el-row>

                        <el-row style="margin-top: 15px">
                          <div style="display: inline-block; vertical-align: middle;">
                            <p class="p-title-2">
                              {{ $t("message.Proposal_Cost") }}
                              
                              <el-popover placement="top-start" trigger="hover" >
                                <div>
                                　<span>{{$t('message.Proposal_Cost_Exp')}}</span>
                                </div>
                                <el-button icon="el-icon-info" circle slot="reference" style="border:0px; background-color: #F6F6F6;"></el-button>
                              </el-popover>
                            </p>
                            <p class="p-content-2">{{ proposal_discount_cost.toLocaleString() }}</p>
                          </div>
                          <div style="display: inline-block; margin-left: 20px">
                            <el-button type="primary" :style="{background: discount_warning ? '#E6A23C':'#409EFF', borderColor: discount_warning ? '#E6A23C':'#409EFF'}" 
                              @click="pricingVisible = !pricingVisible">
                              {{ $t("message.Pricing") }}
                            </el-button>
                          </div>
                        </el-row>
                        
                        <el-row style="margin-top: 15px">  
                          <el-col :span="24" v-if="!ifShowViewed">
                              <p class="p-title-2">
                                {{ $t("message.Proposal_CPM") }}
                              </p>
                              <p class="p-content-2" style="font-size: 26px">￥{{ discount_proposal_CPM }}</p>
                          </el-col>
                          <el-col :span="24" v-if="ifShowViewed">
                              <p class="p-title-2">
                                {{ $t("message.Proposal_CPM_Selection_And_Total") }}
                              </p>
                              <span class="p-content-2" style="font-size: 22px">￥{{ discount_adjusted_proposal_CPM }} / </span> 
                              <span class="p-content-2" style="font-size: 26px">￥{{ discount_proposal_CPM }}</span>
                          </el-col>
                        </el-row>
                      </el-col>

                    </el-row>
                  </el-col>
                  <!--
                  <el-col :span="14" style="border-top: 1px solid #ced4da; padding-bottom: 20px">
                    <el-row style="margin-top: 30px">
                      <el-col :span="8" >
                        <p class="p-title-2">{{ $t("message.Media_Cost") }}</p>
                        <p class="p-content-2">
                          ￥{{ media_discount_cost.toLocaleString() }}
                        </p>
                      </el-col>
                      <el-col :span="8" >
                        <p class="p-title-2">{{ $t("message.Production_Cost_1") }}</p>
                        <p class="p-content-2">
                          ￥{{ production_discount_cost.toLocaleString() }}
                        </p>
                      </el-col>
                      <el-col :span="8">
                        <div style="display: flex;">
                          <div style="width: 100%;">
                            <p class="p-title-2">{{ $t("message.Proposal_Cost") }}</p>
                            <p class="p-content-2">
                              ￥{{ proposal_discount_cost.toLocaleString() }} 
                              <i class="el-icon-edit" style="color: black; cursor: pointer;" @click="pricingVisible = !pricingVisible"></i>
                            </p>
                          </div>
                        </div>
                      </el-col>
                    </el-row>
                    <el-row :gutter="20" style="margin-top: 20px" v-if="pricingMode == 'proposal'">
                      <el-col :span="12" v-if="!ifShowViewed">
                          <p class="p-title-2">
                            {{ $t("message.Rate_Card_Proposal_CPM") }}
                            <el-popover
                              placement="top-start"
                              width="300"
                              trigger="hover"
                              :content="$t('message.textCPM')"
                            >
                              <el-button
                                icon="el-icon-info"
                                circle
                                slot="reference"
                                style="border: 0px"
                              ></el-button>
                            </el-popover>
                          </p>
                        <p class="p-content-2" style="font-size: 30px">￥{{ proposal_CPM }}</p>
                      </el-col>
                      <el-col :span="12" v-if="ifShowViewed">
                          <p class="p-title-2">
                            {{ $t("message.Rate_Card_Proposal_CPM_Total_And_Selection") }}
                            <el-popover
                              placement="top-start"
                              width="300"
                              trigger="hover"
                              :content="$t('message.textCPM')"
                            >
                              <el-button
                                icon="el-icon-info"
                                circle
                                slot="reference"
                                style="border: 0px"
                              ></el-button>
                            </el-popover>
                          </p>
                          <p class="p-content-2" style="font-size: 30px">￥{{ proposal_CPM }} / ￥{{ adjusted_proposal_CPM }}</p>
                      </el-col>
                      <el-col :span="12" v-if="!ifShowViewed">
                          <p class="p-title-2">
                            {{ $t("message.Proposal_CPM") }}
                          </p>
                          <p class="p-content-2" style="font-size: 30px">￥{{ discount_proposal_CPM }}</p>
                      </el-col>
                      <el-col :span="12" v-if="ifShowViewed">
                          <p class="p-title-2">
                            {{ $t("message.Proposal_CPM_Total_And_Selection") }}
                          </p>
                          <p class="p-content-2" style="font-size: 30px">￥{{ discount_proposal_CPM }} / ￥{{ discount_adjusted_proposal_CPM }}</p>
                      </el-col>
                    </el-row>
                    <el-row :gutter="20" style="margin-top: 20px" v-else>
                      <el-col :span="12" v-if="!ifShowViewed">
                          <p class="p-title-2">
                            {{ $t("message.Rate_Card_Media_CPM") }}
                            <el-popover
                              placement="top-start"
                              width="300"
                              trigger="hover"
                              :content="$t('message.textCPM')"
                            >
                              <el-button
                                icon="el-icon-info"
                                circle
                                slot="reference"
                                style="border: 0px"
                              ></el-button>
                            </el-popover>
                          </p>
                        <p class="p-content-2" style="font-size: 30px">￥{{ media_CPM }}</p>
                      </el-col>
                      <el-col :span="12" v-if="ifShowViewed">
                          <p class="p-title-2">
                            {{ $t("message.Rate_Card_Media_CPM_Total_And_Selection") }}
                            <el-popover
                              placement="top-start"
                              width="300"
                              trigger="hover"
                              :content="$t('message.textCPM')"
                            >
                              <el-button
                                icon="el-icon-info"
                                circle
                                slot="reference"
                                style="border: 0px"
                              ></el-button>
                            </el-popover>
                          </p>
                          <p class="p-content-2" style="font-size: 30px">￥{{ media_CPM }} / ￥{{ adjusted_media_CPM }}</p>
                      </el-col>
                      <el-col :span="12" v-if="!ifShowViewed">
                          <p class="p-title-2">
                            {{ $t("message.Media_CPM") }}
                          </p>
                          <p class="p-content-2" style="font-size: 30px">￥{{ discount_media_CPM }}</p>
                      </el-col>
                      <el-col :span="12" v-if="ifShowViewed">
                          <p class="p-title-2">
                            {{ $t("message.Media_CPM_Total_And_Selection") }}
                          </p>
                          <p class="p-content-2" style="font-size: 30px">￥{{ discount_media_CPM }} / ￥{{ discount_adjusted_media_CPM }}</p>
                      </el-col>
                    </el-row>
                  </el-col>
                  -->
                </el-row>
              </div>
              <!-- -->
              <el-main>
                <el-row type="flex" class="row-bg" justify="space-between">
                  <el-col :span="4">
                    <div class="div_navi">
                      <p class="p_navi_button" v-on:click="goBack">
                        {{ $t("message.Back") }}
                      </p>
                    </div>
                  </el-col>

                  <el-col :span="8">
                    <div></div>
                  </el-col>

                  <el-col :span="4">
                    <div style="background-color: #909399">
                      <p class="p_navi_button" v-on:click="verifyBusBody">
                      <!--<p class="p_navi_button" v-on:click="goNext">-->
                        {{ $t("message.Next") }}
                      </p>
                    </div>
                  </el-col>
                </el-row>
                <mapf ref="mapf" style="margin-top: 20px" :mapId="'amap-container'" isBusMap=true></mapf>
              </el-main>
              <el-footer></el-footer>
            </el-container>
          </el-container>

          <div class="hidden-md-and-up">
            <div
              :class="menuFixed == true ? 'isFixed' : ''"
              style="
                margin-top: 0;
                padding: 5px 0 10px 0;
                background-color: rgb(246, 246, 246);
              "
            >
              <el-row>
                <el-col class="hidden-sm-and-up" :span="24">
                  <el-form ref="form" label-width="60%">
                    <el-form-item
                      :label="$t('message.Number_of_Lines_And_Bus')"
                    >
                      {{ tableData[0].value }} / {{ tableData[1].value }}
                    </el-form-item>
                    <el-form-item
                      :label="$t('message.Campaign_Starting_Date_And_Duration')"
                    >
                      {{ this.dataInfo.date.split("T")[0] }} / {{ tableData[2].value }} {{$t('message.Month')}}
                    </el-form-item>
                    <el-form-item
                      v-if="!ifShowViewed"
                      :label="$t('message.Viewed_Impression')"
                    >
                      {{ tableData[4].value }}
                    </el-form-item>
                    <el-form-item
                      v-if="ifShowViewed"
                      :label="
                        $t('message.Viewed_Impression_Total_And_Selection')
                      "
                    >
                      {{ viewedImpressionTotalAndSection }}
                    </el-form-item>
                    <el-form-item :label="$t('message.Total_Media_Cost_1')">
                      ￥{{ estimated_cost }}
                    </el-form-item>
                    <el-form-item
                      v-if="!ifShowViewed"
                      :label="$t('message.Gross_CPM_1')"
                    >
                      ￥{{ CPM }}
                    </el-form-item>
                    <el-form-item
                      v-if="ifShowViewed"
                      :label="$t('message.CPM_Total_And_Selection')"
                    >
                      ￥{{ CPM }} / ￥{{ adjusted_CPM }}
                    </el-form-item>
                  </el-form>
                </el-col>
                
                <el-col class="hidden-xs-only" :span="12">
                  <el-form ref="form" label-width="60%" style="margin-top: 15px">
                    <el-form-item
                      :label="$t('message.Number_of_Lines_And_Bus')"
                    >
                      {{ tableData[0].value }} / {{ tableData[1].value }}
                    </el-form-item>
                    <el-form-item
                      :label="$t('message.Campaign_Starting_Date_And_Duration')"
                    >
                      {{ this.dataInfo.date.split("T")[0] }} / {{ tableData[2].value }} {{$t('message.Month')}}
                    </el-form-item>
                    <el-form-item
                      v-if="!ifShowViewed"
                      :label="$t('message.Viewed_Impression')"
                    >
                      {{ tableData[4].value }}
                    </el-form-item>
                    <el-form-item
                      v-if="ifShowViewed"
                      :label="
                        $t('message.Viewed_Impression_Total_And_Selection')
                      "
                    >
                      {{ viewedImpressionTotalAndSection }}
                    </el-form-item>
                    <el-form-item :label="$t('message.Total_Media_Cost_1')">
                      ￥{{ estimated_cost }}
                    </el-form-item>
                    <el-form-item
                      v-if="!ifShowViewed"
                      :label="$t('message.Gross_CPM_1')"
                    >
                      ￥{{ CPM }}
                    </el-form-item>
                    <el-form-item
                      v-if="ifShowViewed"
                      :label="$t('message.CPM_Total_And_Selection')"
                    >
                      ￥{{ CPM }} / ￥{{ adjusted_CPM }}
                    </el-form-item>
                  </el-form>
                </el-col>
                <el-col v-if="screenWidth>=768" :span="12">
                  <strong style="font-size:12px">{{ $t("message.Index_Performance") }}</strong><strong>{{this.radialBarData}}</strong>
                  <v-gauge
                    :value="radialBarData"
                    :options="radialBarOptions"
                    height ="100px"
                    width="150px"
                    :minValue="50"
                    :maxValue="150"
                  />
                </el-col>
                <el-col :span="24">
                  <el-divider></el-divider>
                </el-col>
                <el-col :span="24" style="font-size: 14px">
                  {{ $t("message.Recommended_Bus_Lines") }}
                </el-col>
                <el-col :span="24">
                  <el-select
                    v-model="multiple.selectedList"
                    multiple
                    collapse-tags
                    style="width: 70%; max-width: 400px; margin: 5px 0"
                    placeholder="Please Select ..."
                    :popper-append-to-body="false"
                    filterable
                    remote
                  >
                    <el-option
                      v-for="item in multiple.originOptions"
                      :key="item.id"
                      :label='$i18n.locale == "en" ?
                          item.name.replace("Line ", "").replace("路", "").replace("高峰快巴", "Peak Express ").replace("高峰专线", "Peak Line ")
                          : item.name.replace("Line ", "").replace("路", "")'
                      :value="item.id"
                      >{{ $i18n.locale == "en" ?
                          item.name.replace("Line ", "").replace("路", "").replace("高峰快巴", "Peak Express ").replace("高峰专线", "Peak Line ")
                          : item.name.replace("Line ", "").replace("路", "") }}</el-option
                    >
                  </el-select>
                  <el-button size="mini" style="margin-left: 10px" @click="selectAllLines">
                    {{ $i18n.locale == 'en' ? 'Select All' : '全选' }}
                  </el-button>
                </el-col>
                <el-col :span="8" :offset="8" class="refreshButton">
                  <el-button
                    @click="refreshPanelButton"
                    style="background-color: white"
                    >
                    {{ $t("message.Refresh") }}
                  </el-button>
                </el-col>
                <el-col :span="8" class="refreshButton" style="text-align: right; padding-right: 5%;">
                  <el-button type="primary"
                    @click="goNext"
                    >
                    {{ $t("message.Next") }}
                  </el-button>
                </el-col>
              </el-row>
            </div>

            <div class="hidden-sm-and-up"
              v-if="menuFixed && $i18n.locale == 'cn'"
              style="padding-top: 227px; background-color: white"
            ></div>
            <div class="hidden-sm-and-up"
              v-if="menuFixed && $i18n.locale == 'en'"
              style="padding-top: 227px; background-color: white"
            ></div>

            <el-table
              ref="multipleTable"
              :data="selectedOptions"
              tooltip-effect="dark"
              style="width: 100%; font-size: 12px"
              :show-headser="false"
              @selection-change="handleSelectionChange"
              :header-row-style="{ color: '#254A6E', 'font-weight': 'bold' }"
            >
              <el-table-column type="selection" min-width="30">
              </el-table-column>

              <el-table-column :label="$t('message.Line')" min-width="45">
                <template slot-scope="scope" style="text-align: center">{{
                  $i18n.locale == 'en' ? 
                    scope.row.name.replace("Line ", "").replace("路", "").replace("高峰快巴", "Peak Express ").replace("高峰专线", "Peak Line ")
                    : scope.row.name.replace("Line ", "").replace("路", "")
                }}</template>
              </el-table-column>
              <el-table-column min-width="51">
                <template slot="header">
                  {{ $t("message.index2") }}
                </template>
                <template slot-scope="scope" style="text-align: center">
                  {{ scope.row.rate }}
                </template>
              </el-table-column>
              <el-table-column v-if="screenWidth>=768 && !ifShowViewed" min-width="60">
                <template slot="header">
                  {{ $t("message.Viewed_Impression") }}
                </template>
                <template slot-scope="scope" style="text-align: center">
                  {{ (scope.row.IMP * tableData[2].value).toLocaleString() }}
                </template>
              </el-table-column>
              <el-table-column v-if="screenWidth>=768 && ifShowViewed" min-width="130">
                <template slot="header">
                  {{ $t("message.Viewed_Impression_Total_And_Selection") }}
                </template>
                <template slot-scope="scope" style="text-align: center">
                  {{ (scope.row.IMP * tableData[2].value).toLocaleString() }} / {{ (scope.row.target_IMP * tableData[2].value).toLocaleString() }}
                </template>
              </el-table-column>
              <el-table-column v-if="screenWidth>=768  && !ifShowViewed" min-width="60">
                <template slot="header">
                  {{ $t("message.CPM") }}
                </template>
                <template slot-scope="scope" style="text-align: center">
                  ￥{{ scope.row.CPM.toLocaleString() }}
                </template>
              </el-table-column>
              <el-table-column v-if="screenWidth>=768  && ifShowViewed" min-width="115">
                <template slot="header">
                  {{ $t("message.CPM_Total_And_Selection") }}
                </template>
                <template slot-scope="scope" style="text-align: center">
                  ￥{{ scope.row.CPM.toLocaleString() }} / ￥{{ scope.row.adjusted_CPM.toLocaleString() }}
                </template>
              </el-table-column>
              <el-table-column :min-width="screenWidth>=768 && !ifShowViewed? 60 : 120">
                <template slot="header">
                  <span>{{ $t("message.operation") }}</span>
                  <div style="display: inline-block">
                    <span style="margin-left: 1em"
                      >{{ $t("message.Bus_Body") }}:</span
                    >
                    <input
                      style="margin-left: 1em; display: inline; width: 1.5em"
                      @change="busbodyGlobalChange"
                      v-model="busbodyGlobal"
                    />
                  </div>
                </template>
                <template slot-scope="scope">
                  <el-row>
                    <el-popover placement="top" trigger="click">
                      <div>
                        <el-row>
                          <el-col :span="8"
                            >{{ $t("message.Bus_Body") }}:</el-col
                          >
                          <el-col :span="16">
                            <el-input
                              size="mini"
                              v-model="busbody[scope.$index]"
                            ></el-input>
                          </el-col>
                        </el-row>
                      </div>
                      <div>
                        <el-row>
                          <el-col :span="8">{{ $t("message.Format") }}:</el-col>
                          <el-col :span="16">
                            <el-select
                              v-model="media_formats[scope.$index]"
                              size="mini"
                            >
                              <el-option
                                v-if="$i18n.locale == 'en'"
                                v-for="item in media_format_options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                              >
                                <span>{{ item.label }}</span>
                              </el-option>

                              <el-option style="padding: 12px 18px;"
                                v-if="$i18n.locale == 'cn'"
                                v-for="item in media_format_options"
                                :key="item.value"
                                :label="item.label_cn"
                                :value="item.value"
                              >
                                <span>{{ item.label_cn }}</span>
                              </el-option>
                            </el-select>
                          </el-col>
                        </el-row>
                      </div>

                      <el-button style="padding: 12px 18px;"
                        slot="reference"
                        icon="el-icon-more"
                        type="info"
                        plain
                      ></el-button>
                    </el-popover>
                    <span v-if="screenWidth>=768" style="margin-left: 15px"></span>
                    <el-button style="padding: 12px 18px;"
                      type="info"
                      plain
                      @click.native.prevent="
                        deleteRow(scope.$index, selectedOptions)
                      "
                      icon="el-icon-delete"
                    ></el-button>
                  </el-row>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <el-dialog
          :title="$t('message.Notice')"
          :visible.sync="dialogVisible"
          width="30%"
        >
          <span>{{ $t("message.Notice_dia") }}</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="handleDiaYes">确 定</el-button>
          </span>
        </el-dialog>
      </el-main>

      <el-dialog
          :title="$t('message.Notice')"
          :visible.sync="nextPageDialogVisble"
          width="40%"
        >
          <p v-for="warn in warning" :key="warn">
            {{warn}}
          </p>
          <br/>
          <p>{{ $t("message.Notice_Content") }}</p>
          <span slot="footer" class="dialog-footer">
            <el-button @click="nextPageDialogVisble = false">{{ $t("message.Notice_Cancel") }}</el-button>
            <el-button type="primary" @click="goNext()">{{ $t("message.Notice_Yes") }}</el-button>
          </span>
      </el-dialog>

      <el-dialog
        :title="$t('message.Notice')"
        :visible.sync="processDialogVisible"
        width="40%">
        <el-row style="margin: 10px">
          <span>{{$t('message.Discount_Notice')}}</span>
        </el-row>
        <el-row style="margin: 10px">
          <span style="margin: 10px">{{$t('message.Client_Name_Notice')}}</span>
          <el-input v-model="clientName" style="width: 40%"></el-input>
        </el-row>
        <span> <el-alert style="width: 90%; margin: auto" v-if = "no_salesdirector"
            :title="$t('message.No_salesdirector_Warning')" type="warning" :center="true" :closable="false"
            show-icon>
          </el-alert></span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="processDialogVisible = false">{{ $t("message.Notice_Cancel") }}</el-button>
          <el-button type="primary" @click="saveProcess('pricing')">{{ $t("message.Notice_Yes") }}</el-button>
        </span>
      </el-dialog>

      <el-drawer
        size="50%"
        :title="$t('message.Pricing')"
        :visible.sync="pricingVisible"
        :direction="'rtl'"
        @opened="pricingDrawerOpened"
        >
        <!--:before-close="handleClose"-->
        <!-- 模式  pricingMode false媒体 true提案-->
        <el-row style="margin: 5px 10px;">
          <el-popover placement="top-start" trigger="hover" >
            <div>
            　<span>{{$t('message.Media_Discount_Exp')}}</span>
            </div>
            <el-button icon="el-icon-info" circle slot="reference" style="border:0px; background-color: #F6F6F6;"></el-button>
          </el-popover>
          <el-switch
            style="display: inline; vertical-align: text-top;"
            v-model="pricingMode"
            @change="changePricingMode"
            inactive-color="#13ce66"
            :inactive-text='$t("message.Media_Discount")'
            :active-text='$t("message.Proposal_Discount")'
            inactive-value="media"
            active-value="proposal">
          </el-switch>
          <el-popover placement="top-start" trigger="hover" >
            <div>
            　<span>{{$t('message.Proposal_Discount_Exp')}}</span>
            </div>
            <el-button icon="el-icon-info" circle slot="reference" style="border:0px; background-color: #F6F6F6;"></el-button>
          </el-popover>
        </el-row>

        <el-row  style="margin: 20px 0">
          <el-divider></el-divider>
        </el-row>

        <!-- 折扣 -->
        <el-row style="margin: 20px 10px 0 10px; font-weight: bold;">
          <el-alert style="width: 90%; margin: auto" v-if="discount_warning && !is_external_user"
            :title="$t('message.Discount_Warning')" type="warning" :center="true" :closable="false"
            show-icon>
          </el-alert>
          <el-alert style="width: 90%; margin: auto" v-if="discount_warning && is_external_user"
            :title="$t('message.Discount_Warning_External')" type="warning" :center="true" :closable="false"
            show-icon>
          </el-alert>
          <el-row class="pricing-row" style="color:#53ADBC; ">
            <el-col :span="6" :offset="6">
              {{$t('message.Rate_Card_Price')}}
            </el-col>
            <el-col :span="6">
              {{$t('message.Reduced_Rate')}}
            </el-col>
            <el-col :span="6">
              {{$t('message.Discounted_Price')}}
            </el-col>
          </el-row>
          <el-row class="pricing-row">
            <el-col :span="6">
              {{$t('message.Media_Cost')}}
            </el-col>
            <el-col :span="6">
              {{media_cost}}
            </el-col>
            <el-col :span="6">
              <div v-if="pricingMode == 'proposal'">
                {{media_discount}} %
              </div>
              <div v-else>
                <el-input class="percentage-input pricing" v-model="media_discount" @keyup.native="calculateMediaDiscount">
                  <template slot="append">%</template>
                </el-input>
              </div>
            </el-col>
            <el-col :span="6">
              <div v-if="pricingMode == 'proposal'">
                {{media_discount_cost.toLocaleString()}}
              </div>
              <div v-else>
                <el-input class="price-input pricing" v-model="media_discount_cost" @keyup.native="calculateMediaDiscountCost">
                </el-input>
              </div>
            </el-col>
          </el-row>
          <el-row class="pricing-row">
            <el-col :span="6">
              {{$t('message.Production_Cost_1')}}
            </el-col>
            <el-col :span="6">
              {{production_cost}}
            </el-col>
            <el-col :span="6">
              {{production_discount}} %
            </el-col>
            <el-col :span="6">
              {{production_discount_cost.toLocaleString()}}
            </el-col>
          </el-row>
          <el-row class="pricing-row" style="font-weight: bold">
            <el-col :span="6">
              {{$t('message.Proposal_Cost')}}
              <el-popover placement="top-start" trigger="hover" >
                <div>
                　<span>{{$t('message.Total_Cost_Exp')}}</span>
                </div>
                <el-button icon="el-icon-info" circle slot="reference" style="border:0px; background-color: #F6F6F6;"></el-button>
              </el-popover>
            </el-col>
            <el-col :span="6">
              {{proposal_cost}}
            </el-col>
            <el-col :span="6">
              <div v-if="pricingMode == 'proposal'">
                <el-input class="percentage-input pricing" v-model="proposal_discount" @keyup.native="calculateTotalDiscount">
                  <template slot="append">%</template>
                </el-input>
              </div>
              <div v-else>
                {{proposal_discount}} %
              </div>
            </el-col>
            <el-col :span="6">
              <div v-if="pricingMode == 'proposal'">
                <el-input class="price-input pricing" v-model="proposal_discount_cost" @keyup.native="calculateTotalDiscountCost">
                </el-input>
              </div>
              <div v-else>
                {{proposal_discount_cost.toLocaleString()}}
              </div>
            </el-col>
          </el-row>
        </el-row>

        <el-row  style="margin: 20px 0">
          <el-divider></el-divider>
        </el-row>

        <!-- 表格 -->
        <el-row style="width: 80%; margin: 40px auto; font-size: 14px;">
          <el-row style=" font-weight: bold; color: grey; ">
            <el-col :span="6" :offset="6">
              {{$t('message.Impression')}}
            </el-col>
            <el-col :span="6">
              <p>
                {{$t('message.Rate_Card_Proposal_CPM_1')}}
              </p>
            </el-col>
            <el-col :span="6">
              {{$t('message.Proposal_CPM')}}
            </el-col>
          </el-row>
          
          <el-divider></el-divider>
          <el-row type="flex" align="middle">
              <el-col :span="6">
                {{$t('message.Total_Audience')}}
              </el-col>
              <el-col :span="6">
                {{ tableData[4].value }}
              </el-col>
              <el-col :span="6">
                {{ proposal_CPM }}
              </el-col>
              <el-col :span="6">
                <p style="font-size: 20px; font-weight: bolder; font-sytle: italic; color: forestgreen;">
                  {{ discount_proposal_CPM }}
                </p>
              </el-col>
          </el-row>
          
          <el-divider v-if="ifShowViewed"></el-divider>
          <el-row type="flex" align="middle" v-if="ifShowViewed">
            <el-col :span="6">
              {{$t('message.Target_Audience')}}
            </el-col>
            <el-col :span="6">
              {{ tableData[5].value }}
            </el-col>
            <el-col :span="6">
              {{ adjusted_proposal_CPM }}
            </el-col>
            <el-col :span="6">
              <p style="font-size: 20px; font-weight: bolder; font-sytle: italic; color: forestgreen;">
              {{ discount_adjusted_proposal_CPM }}
              </p>
            </el-col>
          </el-row>
        </el-row>


        <!-- 确认按钮 -->
        <el-row style="margin-top: 80px;">  
          <el-button type="primary" @click="pricingVisible = false">{{$t('message.Confirm')}}</el-button> 
        </el-row>

      </el-drawer>
    </el-container>
  </div>
</template>
<script type="text/javascript" src="../static/js/lib/vue.min.js"></script>
<script type="text/javascript" src="../static/js/select-vue-component.js"></script>

<script>
import head_page from "./components/head_page.vue";
import head_menu from "./components/head_menu.vue";
import multiple_choice_search from "./components/multiple_choice_search.vue";
import mapf from "./mapf.vue";
import axios from "axios";
import _global from "./components/global.vue";
import VGauge from "vgauge";
export default {
  name: "appAmap",
  data() {
    return {
      tableData: [
        {
          title: this.$t("message.Number_of_Bus_Lines"),
          value: 0,
        },{
          title: this.$t("message.Number_of_Bus_Body"),
          value: 0,
        },
        {
          title: this.$t("message.Duration(Months)"),
          value: 0,
        },
        {
          title: this.$t("message.Audience_Reach(%)"),
          value: 0,
        },
        {
          title: this.$t("message.Viewed_Impression"),
          value: 0,
        },
        {
          title: this.$t("message.Viewed_Impression(Audience)"),
          value: 0,
        },
        {
          title: this.$t("message.Frequency"),
          value: 0,
        },
        {
          title: this.$t("message.Distinct_Audience"),
          value: 0,
        },
        {
          title: this.$t("message.One_Month_Freq"),
          value: 0,
        },
        {
          title: this.$t("message.Covergae_Percentage"),
          value: 0,
        },
      ],
      dataInfo: {},
      dataMap: {},
      totalInfo: [],
      busbodyGlobal: 1,
      estimated_cost: "",
      CPM: "",
      adjusted_CPM: "",
      media_cost: "",
      production_cost: "",
      proposal_cost: "",
      media_discount: 100,
      production_discount: 100,
      proposal_discount: 100,
      discount_limit: 100,
      discount_warning: false,
      is_external_user: false,
      media_discount_cost: "",
      production_discount_cost: "",
      proposal_discount_cost: "",
      media_CPM: "",
      adjusted_media_CPM: "",
      discount_media_CPM: "",
      discount_adjusted_media_CPM: "",
      proposal_CPM: "",
      adjusted_proposal_CPM: "",
      discount_proposal_CPM: "",
      discount_adjusted_proposal_CPM: "",
      chosen_city: "",
      busLineRank: [],
      lang: this.$i18n.locale,
      loading: true,
      bu: "",
      total_objects: null,
      multiple: {
        originOptions: [],
        selectedList: [], //表格行
      },
      input: "",
      checkboxGroup1: [],
      total: [],
      busbody: [],
      media_formats: [],
      multipleSelection: [], //checkbox
      ifShowViewed: true,
      media_format_options: [],
      dataValueBadge: 0,
      mediaFormatsDefalutValue: 1,
      dialogVisible: false,
      nextPageDialogVisble: false,
      processDialogVisible: false,
      diaYes: false,
      indexChartData: [
        {
          name: "Series 1",
          data: [
            {
              x: "50",
              y: 0,
            },
            {
              x: "60",
              y: 0,
            },
            {
              x: "70",
              y: 0,
            },
            {
              x: "80",
              y: 0,
            },
            {
              x: "90",
              y: 0,
            },
            {
              x: "100",
              y: 0,
            },
            {
              x: "110",
              y: 0,
            },
            {
              x: "120",
              y: 0,
            },
            {
              x: "130",
              y: 0,
            },
            {
              x: "140",
              y: 0,
            },
          ],
        },
      ],
      rankChartData: [
        {
          name: "Series 1",
          data: [
            {
              x: "S",
              y: 0,
            },
            {
              x: "A++",
              y: 15,
            },
            {
              x: "A+",
              y: 4,
            },
            {
              x: "A",
              y: 5,
            }
          ],
        },
      ],

      indexChartOptions: {
        grid: {
          show: true,
        },
        chart: {
          type: "heatmap",
          toolbar: {
            show: false,
          },
        },
        xaxis: {
          type: "category",
          categories: ["50", "", "", "", "", "100", "", "", "", "150"],
          labels: {
            show: true,
          },
          tooltip: {
            enabled: false,
          }
        },
        yaxis: {
          labels: {
            show: false,
          },
        },
        dataLabels: {
          enabled: true,
        },
        inverseOrder: true,
        tooltip: {
          enabled: true,
          x: {
            show: false,
          },
          y: {
            show: false,
            title: {
              formatter: function (value, {series, seriesIndex, dataPointIndex, w}) {
                let index = dataPointIndex*10 + 50
                let text = index.toString() + ' - ' + (index+10).toString() + ' : '
                return  text;
              },
            },
          },
          fixed:{
            enabled:true,
            position:'topRight'
          }
        },
        colors: ["#008FFB"],
        plotOptions: {
          heatmap: {
            colorScale: {
            ranges: [
              {
                from: 0,
                to: 1,
                color: '#c4e6ff'
              },
            ]
          }
          }
        },        
      },
      rankChartOptions: {
        grid: {
          show: true,
        },
        chart: {
          type: "heatmap",
          toolbar: {
            show: false,
          },
        },
        xaxis: {
          type: "category",
          categories: ["S","A++","A+","A","B"],
          labels: {
            show: true,
          },
          tooltip: {
            enabled: false,
          }
        },
        yaxis: {
          labels: {
            show: false,
          },
        },
        dataLabels: {
          enabled: true,
        },
        inverseOrder: true,
        tooltip: {
          enabled: true,
          
          x: {
            show: false,
          },
          y: {
            show: false,
            title: {
              formatter: function (value, {series, seriesIndex, dataPointIndex, w}) {
                let text = ""
                switch (dataPointIndex) {
                  case 0:
                    text = "S: "
                    break;
                  case 1:
                    text = "A++: "
                    break;
                  case 2:
                    text = "A+: "
                    break;
                  case 3:
                    text = "A: "
                    break;
                  case 4:
                    text = "B: "
                    break;
                }
                return text;
              },
            },
          },
          fixed:{
            enabled:true,
            position:'topRight'
          },
        },
        colors: ["#008FFB"],
        plotOptions: {
          heatmap: {
            colorScale: {
            ranges: [
              {
                from: 0,
                to: 1,
                color: '#c4e6ff'
              },
            ]
          }
          }
        }
        
      },
      radialBarData: 50,
      radialBarOptions: {
        angle: 0,
        lineWidth: 0.15,
        radiusScale: 0.75,
        pointer: {
          length: 0.55, // // Relative to gauge radius
          strokeWidth: 0.02, // The thickness
          color: "#000000", // Fill color
        },
        staticLabels: {
          font: "10px sans-serif", // Specifies font
          labels: [50, 100, 150], // Print labels at these values
          color: "#000000", // Optional: Label text color
          fractionDigits: 0, // Optional: Numerical precision. 0=round off.
        },
        staticZones: [
          { strokeStyle: "#9FA8DA", min: 50, max: 100 }, // Red from 100 to 130
          { strokeStyle: "#90CAF9", min: 100, max: 150 }, // Yellow
        ],
      },
      diaYes: false,
      menuFixed: false,
      warning: [],
      screenWidth: window.innerWidth,
      imp: 0,
      target_imp: 0,
      timeoutId : "",
      pricingVisible: false,
      pricingMode: "media",
      clientName: "",
      no_salesdirector: false,
      value_vendor:[],
      value_date:new Date().getTime()
    };
  },
  computed: {
    l1: function () {
      return this.ifShowViewed ? 12 : 24;
    },
    l2: function () {
      return this.ifShowViewed ? 12 : 0;
    },
    selectedOptions: function () {
      // 搜索框选的内容
      let temp = [];
      this.multiple.selectedList = this.multiple.selectedList.map((ele) =>
        ele.replace(" ", "_")
      );
      for (let ele of this.multiple.selectedList) {
        for (let ele2 of this.multiple.originOptions) {
          if (ele2.id == ele) {
            temp.push(ele2);
          }
        }
      }
      this.checkboxGroup1 = this.multiple.selectedList;
      return temp;
    },
    chosen_city_shown: function () {
      let tmp = "message." + this.chosen_city;
      return this.$t(tmp);
    },
    offsetTop() {
      return document.querySelector("#menu").offsetTop;
    },
    viewedImpressionTotalAndSection() {
      let result = "";
      if (this.tableData && this.tableData[4] && this.tableData[5]) {
        result =
          this.intToString(this.tableData[4].value) +
          " / " +
          this.intToString(this.tableData[5].value);
      }
      return result;
    },
    coveragePercentageTooltip() {
      const baseText = "城市人口中看到广告至少一次的人群比例";
      if (this.chosen_city === "Chongqing") {
        return baseText + "。重庆选取城区人口1064万";
      } else if (this.chosen_city === "Nanjing") {
        return baseText + "。南京选取城区人口545万";
      }
      return baseText;
    },
  },
  watch: {
    checkboxGroup1: function (val) {
      this.multiple.selectedList = this.checkboxGroup1;
    },
    selectedOptions: function (val, oldVal) {
      if (oldVal.length - val.length == 1) {
        //多选栏减少
        let val_id_arr = [];
        let oldVal_id_arr = [];
        for (let ele of val) {
          val_id_arr.push(ele.id);
        }
        for (let ele of oldVal) {
          oldVal_id_arr.push(ele.id);
        }
        let deletedVal = this.arr_diff(val_id_arr, oldVal_id_arr);
        let deletedIndex = oldVal_id_arr.indexOf(deletedVal[0]);
        if (deletedIndex > -1) {
          this.busbody.splice(deletedIndex, 1);
        }
      } else if (val.length - oldVal.length == 1) {
        //多选栏增加
        this.busbody.push("1");
        this.media_formats.push(this.mediaFormatsDefalutValue);
      }
    },
    multipleSelection: function (val) {},
    busbody: function (val, oldval) {},
    multiple: function (val) {},
    proposal_discount_cost(val) {
      if (this.imp && this.target_imp) {
        this.discount_proposal_CPM = (val / this.imp * 1000).toFixed(2)
        this.discount_adjusted_proposal_CPM = (val / this.target_imp * 1000).toFixed(2)
      }
    },
    media_discount_cost(val) {
      if (this.imp && this.target_imp) {
        this.discount_media_CPM = (val / this.imp * 1000).toFixed(2)
        this.discount_adjusted_media_CPM = (val / this.target_imp * 1000).toFixed(2)
      }
    }
  },
  beforeCreate() {},
  created() {
    this.busbody = [...Array(30)].map((_) => "1");
    document.title = "Map";
    this.discount_limit = JSON.parse(sessionStorage.getItem('UserAuthority'))['discount'];
    this.is_external_user = JSON.parse(sessionStorage.getItem('UserAuthority'))['is_external_user'];
    this.chosen_city = this.$route.query.chosen_city;
    // 获取前页的数值 并处理
    this.dataInfo = this.getDataInformation();
    let dataHistory = JSON.parse(sessionStorage.getItem('Data_History'))
    //this.rankOptions = dataOptions.media_rank_options.rank_options
    this.updateRankChart()
    if (this.dataInfo.isEdit && dataHistory != null) {
      this.media_format_options = dataHistory.options.media_rank_options.media_format_options;
      this.handleBusBodyAndMediaFormat(dataHistory);
      this.getBusLineData("edit");
    } else {
      this.media_format_options = this.dataInfo.media_format_options;
      this.getBusLineData("created");
    }
    window.addEventListener("scroll", this.handleScroll); //监听滑动事件
    this.addPageView(this.chosen_city)
  },
  mounted() {
    this.lang = JSON.parse(sessionStorage.getItem("lang"));
    this.$i18n.locale = this.lang;
    this.$refs.head_page.switchLang(this.lang);
    let UserAuthority = JSON.parse(sessionStorage.getItem("UserAuthority"));
    this.bu = UserAuthority.bu;
    this.getReportLength();

    this.open4();
    this.$refs.head_page.update_user_name();
    window.addEventListener('resize', this.handleResize);
    
  },
  methods: {
    addPageView(city) {
      let api_url = _global.serverSrc + "/user_page_view/" + "?city=" + city;
      let obj = new Object();
      obj.email = JSON.parse(sessionStorage.getItem("User"));
      this.$axios
        .post(api_url, obj)
        .then((response) => {
          
        })
        .catch(function (error) {});
    },
    handleResize() {
      this.screenWidth = window.innerWidth;
    },
    handleDiaYes() {
      this.dialogVisible = false;
      this.busbody = [...Array(this.busbody.length)].map(
        (_) => this.busbodyGlobal
      );
    },
    busbodyGlobalChange() {
      if (this.busbody.every((el) => el === this.busbody[0])) {
        this.busbody = [...Array(this.busbody.length)].map(
          (_) => this.busbodyGlobal
        );
      } else {
        this.dialogVisible = true;
      }
    },
    handleBusBodyAndMediaFormat(dataHistory) {
      this.busbody = dataHistory.bus_line.map(
        (busLine) => busLine.bus_quantity
      );
      this.media_formats = dataHistory.bus_line.map(
        (busLine) => busLine.media_type
      );
    },
    goHistory() {
      this.$router.push("./history");
    },
    deleteRow(index, rows) {
      //删除表格的行
      rows.splice(index, 1);
      // 删除multipleSelection
      this.multipleSelection.splice(index, 1);
      this.multiple.selectedList.splice(index, 1);
      //删除busbody
      this.busbody.splice(index, 1);
      //删除busmedia
      this.media_formats.splice(index, 1);
      //指定的列选中,还不行，无法区分
      this.toggleSelection(this.multipleSelection);
    },
    getReportLength() {
      let api_url = _global.serverSrc + "/report_length/" + "?format=json";
      let obj = new Object();
      obj.email = JSON.parse(sessionStorage.getItem("User"));
      this.$axios
        .post(api_url, obj)
        .then((response) => {
          if (response.data.report_length) {
            this.dataValueBadge = response.data.report_length[0].report_number;
          }
        })
        .catch(function (error) {});
    },
    toggleSelection(rows) {
      if (rows && rows.length > 0) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    arr_diff: function (a1, a2) {
      var a = [],
        diff = [];

      for (var i = 0; i < a1.length; i++) {
        a[a1[i]] = true;
      }

      for (var i = 0; i < a2.length; i++) {
        if (a[a2[i]]) {
          delete a[a2[i]];
        } else {
          a[a2[i]] = true;
        }
      }

      for (var k in a) {
        diff.push(k);
      }

      return diff;
    },

    saveBody: function (a) {
    },
    toPercent: function (point) {
      var str = Number(point * 100).toFixed(0);
      //现在要求去除百分号
      //str += "%";
      return str;
    },
    formatOriginOptions: function (bus_line) {
      var bus_lines = [];
      for (let ele in bus_line) {
        var norm_bus_line = {
          id: 0,
          name: "default",
          rate: "default",
          format_code: [0],
          rank_tag: "",
          value_rank: 0,
          vendor_name:"",
          has_inventory: false,
          total: 0,
          total_available: 0,
          total_available_after_contract: 0,
          total_available_after_reservation: 0,
          hub_valid_bus_body: 0,
          hub_total_bus_body: 0,
          IMP: 0,
          target_IMP: 0,
          CPM: "",
          adjusted_CPM: "",
          hot_config: 0,
          available_formats: [],
          priority_to_sell: false,
        };
        norm_bus_line.id = bus_line[ele].bus_id;
        norm_bus_line.name = bus_line[ele].bus_name;
        norm_bus_line.rate = this.toPercent(bus_line[ele].value_rating);
        norm_bus_line.format_code = bus_line[ele].format_code;
        norm_bus_line.rank_tag = bus_line[ele].rank_tag;
        norm_bus_line.value_rank = bus_line[ele].value_rank;
        norm_bus_line.related_poi_nb = bus_line[ele].related_poi_nb;
        norm_bus_line.vendor_name = bus_line[ele].vendor_name;
        norm_bus_line.has_inventory = bus_line[ele].hub_total_bus_body != -1
        norm_bus_line.total = bus_line[ele].total
        norm_bus_line.total_available = bus_line[ele].total_available
        norm_bus_line.total_available_after_contract = bus_line[ele].total_available_after_contract
        norm_bus_line.total_available_after_reservation = bus_line[ele].total_available_after_reservation
        norm_bus_line.hub_bus_id = bus_line[ele].hub_bus_id
        norm_bus_line.hub_media_format_code = bus_line[ele].hub_media_format_code
        norm_bus_line.hub_valid_bus_body = bus_line[ele].hub_valid_bus_body
        norm_bus_line.hub_total_bus_body = bus_line[ele].hub_total_bus_body
        norm_bus_line.IMP = bus_line[ele].IMP
        norm_bus_line.target_IMP = bus_line[ele].target_IMP
        norm_bus_line.CPM = bus_line[ele].CPM
        norm_bus_line.adjusted_CPM = bus_line[ele].adjusted_CPM
        norm_bus_line.hot_config = bus_line[ele].hot_config ? bus_line[ele].hot_config : 50
        norm_bus_line.available_formats = bus_line[ele].available_formats
        norm_bus_line.priority_to_sell = bus_line[ele].priority_to_sell
        bus_lines.push(norm_bus_line);
      }
      return bus_lines;
    },

    updateRankChart() {
      let dataOptions = JSON.parse(sessionStorage.getItem('Data_Options'))
      let rankOptions = dataOptions.media_rank_options.rank_options
      let data = [];
      let categories = [];
      for (let option of rankOptions) {
        data.push({
          x: option.label,
          y: 0,
        })
        categories.push(option.label)
      }
      this.rankChartData[0].data = data
      this.rankChartOptions.xaxis.categories = categories
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.multipleSelectionSeperateByIndex(val);
      this.multipleSelectionSeperateByRank(val);
    },

    multipleSelectionSeperateByIndex(selection) {
      let numByIndex = {
        140: 0,
        130: 0,
        120: 0,
        110: 0,
        100: 0,
        90: 0,
        80: 0,
        70: 0,
        60: 0,
        50: 0,
      };
      let rangeMax = 141;
      for (let ele in selection) {
        let rate = selection[ele].rate;
        if (rate == 50) {
          rate = 51;
        }
        for (let i = 51; rangeMax; i = i + 10) {
          if (rate >= i && rate < i + 10) {
            numByIndex[(i-1).toString()] += Number(this.busbody[ele]);
            break;
          }
        }
      }

      //Average Index
      let indexSum = 0;
      for (let ele in selection) {
        let rate = parseInt(selection[ele].rate);
        indexSum = indexSum + rate;
      }
      let indexAverage = 0;
      indexAverage = Math.round(indexSum / selection.length);
      this.radialBarData = indexAverage > 50 ? indexAverage : 50;

      //fill in data
      for (let i = 0; i <= 9; i++) {
        this.indexChartData[0]["data"][i]["x"] = "";
        this.indexChartData[0]["data"][i]["y"] = numByIndex[(50 + i * 10).toString()];
      }
      //update to the map
      this.$refs.indexchart.updateSeries(this.indexChartData);
    },

    multipleSelectionSeperateByRank(selection) {
      let map = new Map()
      for (let ele of this.rankChartData[0].data) {
        map.set(ele.x, 0)
      }
      for (let indx in selection) {
        map.set(selection[indx].rank_tag, map.get(selection[indx].rank_tag)+Number(this.busbody[indx]))
      }
      this.rankChartData[0].data.map(ele=> {
        ele.y = map.get(ele.x)
      })
      
      this.$refs.rankchart.updateSeries(this.rankChartData);
    },

    queryData: function (data) {
      var _self = this;

      //do ajax here
      var bus_line = data;
      
      // 过滤线路级别
      if (_self.dataInfo.data_media_rank.value_rank &&
          _self.dataInfo.data_media_rank.value_rank.length > 0) {
        var filtered_bus_line = [];
        var value_rank_array = _self.dataInfo.data_media_rank.value_rank;
        
        for (let ele in bus_line) {
          if (value_rank_array.includes(bus_line[ele].value_rank)) {
            filtered_bus_line.push(bus_line[ele]);
          }
        }
        
        // 如果有匹配的线路，使用过滤后的线路
        if (filtered_bus_line.length > 0) {
          bus_line = filtered_bus_line;
        }
      }
      
      // 多选
      var norm_bus_line = this.formatOriginOptions(bus_line);

      // When there is related poi, default selection only show bus line with related poi
      let default_bus_list_nb = 0;
      for (let ele in norm_bus_line) {
        if (norm_bus_line[ele]["related_poi_nb"] != 0) {
          default_bus_list_nb = default_bus_list_nb + 1;
        } else {
        }
      }

      if (this.dataInfo.poi_ba_value_selection_list.length != 0) {
        if (default_bus_list_nb > 30) {
          default_bus_list_nb = 30;
        } else {
        }
      } else {
        default_bus_list_nb = 30;
      }

      _self.multiple.originOptions = norm_bus_line; //附初值

      let tableDataCommercial = JSON.parse(sessionStorage.getItem('tableDataCommercial'))
      //如果没值，就要搞一个defaultlist
      if (tableDataCommercial && tableDataCommercial.length>0) {
        let chosen_bus_line = []
        let busbody = []
        let media_formats = []
        for (let ele of tableDataCommercial) {
          chosen_bus_line.push(ele.bus_id)
          busbody.push(ele.bus_quantity)
          media_formats.push(ele.media_type)
        }
        this.busbody = busbody
        this.media_formats = media_formats

        this.toChosenSelectedList(chosen_bus_line);
      }
      else if (
        this.multiple.selectedList == null ||
        this.multiple.selectedList.length == 0
      ) {
        let default_chosen_bus_line = [];
        if (norm_bus_line.length > default_bus_list_nb) {
          default_chosen_bus_line = norm_bus_line.slice(0, default_bus_list_nb);
        } else {
          default_chosen_bus_line = norm_bus_line;
        }
        let tableDataCommercial = []
        let dataInformation = JSON.parse(sessionStorage.getItem('Data_Information'))

        for (let ele of default_chosen_bus_line) {
          let obj = {}
          obj = ele
          obj.bus_quantity = 1
          obj.media_type = dataInformation.data_media_rank.value_media_format[0]
          tableDataCommercial.push(obj)
        }
        sessionStorage.setItem('tableDataCommercial', JSON.stringify(tableDataCommercial))
        this.toSelectedList(default_chosen_bus_line);
      }
    },
    toChosenSelectedList(selectedList) {
      let selectedListTemp = [];

      for (let ele of selectedList) {
        selectedListTemp.push(ele);
      }

      this.multiple.selectedList = selectedListTemp;
      this.checkboxGroup1 = this.multiple.selectedList;
    },
    toSelectedList(selectedList) {
      let selectedListTemp = [];

      for (let ele of selectedList) {
        selectedListTemp.push(ele.id);
      }

      this.multiple.selectedList = selectedListTemp;
      this.checkboxGroup1 = this.multiple.selectedList;
    },
    goHome: function () {
      this.$router.push({
        path: "/choose_city",
      });
      let lang = JSON.parse(sessionStorage.getItem("lang"));
      let user = JSON.parse(sessionStorage.getItem("User"));
      let UserAuthority = JSON.parse(sessionStorage.getItem("UserAuthority"));
      sessionStorage.clear();
      sessionStorage.setItem("lang", JSON.stringify(lang));
      sessionStorage.setItem("User", JSON.stringify(user));
      sessionStorage.setItem("UserAuthority", JSON.stringify(UserAuthority));
    },
    open4() {
      /* var _self = this;
        this.$notify({
          message: _self.$t('message.The_data_is_based_on_your_ranking'),
          position: 'top-left'
        }); */
    },
    goBack: function (event) {
      this.$router.push({
        path: "/information",
        query: {
          chosen_city: this.$route.query.chosen_city,
        },
      });
    },

    verifyBusBody() {
      this.warning = []
      this.selectedOptions.forEach((row, i) => {
        if (row.has_inventory && row.total_available_after_contract < this.busbody[i]) {
          let remaining = row.total_available_after_contract
          let text = this.$t('message.Bus_Body_Warning_Text').replace('{{line}}', row.name.replace("Line ", "").replace("路 ", "")).replace('{{remaining}}', remaining).replace('{{selected}}', this.busbody[i])
          if (this.busbody[i] == 1)
            text.replace("bodys", "body")
          this.warning.push(text)
        }
      })
      if (this.warning.length > 0) {
        this.nextPageDialogVisble = true;
      }
      else {
        this.goNext()
      }
    },

    goNext: function (event) {
      let dataNext = new Object();
      dataNext.tableData = this.tableData;
      dataNext.total_bus_lines = this.tableData[0].value;
      dataNext.total_bus_body = this.tableData[1].value;
      dataNext.total_duration = this.tableData[2].value;
      dataNext.total_audience_reach = this.tableData[3].value;
      dataNext.total_audience_impressions = this.tableData[4].value;
      dataNext.total_solution_impressions = this.tableData[5].value;
      dataNext.total_frequency_media = this.tableData[6].value;
      dataNext.distinct_audience = this.tableData[7].value;
      dataNext.one_month_frequency = this.tableData[8].value;
      dataNext.coverage_percantage = this.tableData[9].value;



      dataNext.estimated_cost = this.proposal_discount_cost;
      dataNext.CPM = this.CPM;
      dataNext.adjusted_CPM = this.adjusted_CPM;
      dataNext.media_cost = this.media_cost;
      dataNext.production_cost = this.production_cost;
      dataNext.proposal_cost = this.proposal_cost;

      dataNext.media_discount_cost = this.media_discount_cost
      dataNext.production_discount_cost = this.production_discount_cost
      dataNext.proposal_discount_cost = this.proposal_discount_cost

      dataNext.media_CPM = this.media_CPM;
      dataNext.adjusted_media_CPM = this.adjusted_media_CPM;
      dataNext.proposal_CPM = this.proposal_CPM;
      dataNext.adjusted_proposal_CPM = this.adjusted_proposal_CPM;

      dataNext.discount_media_CPM = this.discount_media_CPM
      dataNext.discount_adjusted_media_CPM = this.discount_adjusted_media_CPM
      dataNext.discount_proposal_CPM = this.discount_proposal_CPM
      dataNext.discount_adjusted_proposal_CPM = this.discount_adjusted_proposal_CPM

      dataNext.media_discount = this.media_discount
      dataNext.proposal_discount = this.proposal_discount
      dataNext.production_discount = this.production_discount
      
      dataNext.ifShowViewed = this.ifShowViewed;
      dataNext.pricingMode = this.pricingMode;

      dataNext.indexChartData = this.indexChartData
      dataNext.rankChartData = this.rankChartData
      dataNext.rankChartCategories = this.rankChartOptions.xaxis.categories

      this.dataMap = dataNext
      // 外部用户不显示折扣警告，直接提交
      if (this.discount_warning && !this.is_external_user) {
        this.processDialog()
        return
      }

      // 如果是外部用户，直接调用保存方法
      if (this.is_external_user) {
        this.saveProcess('standard')
        return
      }

      sessionStorage.setItem('Data_Map', JSON.stringify(dataNext));
      sessionStorage.setItem('ifShowViewed', JSON.stringify(this.ifShowViewed));

      let dataNextDetail = new Object();
      dataNextDetail.multiple = this.multiple;
      dataNextDetail.busbody = this.busbody;
      dataNextDetail.media_formats = this.media_formats;
      dataNextDetail.multipleSelection = this.multipleSelection;
      sessionStorage.setItem('Data_Map_Detail', JSON.stringify(dataNextDetail));
      this.busInfoTrans();
    },

    processDialog() {
      this.processDialogVisible = true
      this.no_salesdirector = false
    },

    async saveProcess(processType) {
      await this.busInfoTrans_2()
      let obj = new Object()
      let dataInformation = JSON.parse(sessionStorage.getItem('Data_Information'))
      obj.data_audience = dataInformation.data_audience
      obj.data_poi = this.changeBoolean(dataInformation.data_poi)
      obj.data_media = dataInformation.data_media_rank.value_media_format
      obj.data_rank = dataInformation.data_media_rank.value_rank
      obj.tableData = this.tableData
      obj.form = {}
      obj.form.name= this.clientName
      obj.bus_line = JSON.parse(sessionStorage.getItem('tableDataCommercial'))
      obj.CPM=this.CPM
      obj.adjusted_CPM=this.adjusted_CPM
      if (dataInformation.value_duration != null){
        obj.duration = dataInformation.value_duration
      }else{
        obj.duration = dataInformation.campaignDuration
      }
      if (dataInformation.date != null){
        let tmp = dataInformation.date.split('T')[0].split('-')
        let date = Date.UTC(tmp[0],tmp[1]-1,tmp[2])
        obj.date = Math.round(date / 1000)
      }else{
        obj.date = dataInformation.campaignDate
      }
      obj.email = JSON.parse(sessionStorage.getItem('User'))
      obj.estimated_cost = this.estimated_cost
      obj.data_map = this.dataMap
      delete obj.data_map.ifShowViewed
      obj.viewed_impression = this.delcommafy(this.tableData[4].value)
      obj.city = this.chosen_city
      let dataOptions = JSON.parse(sessionStorage.getItem('Data_Options'))
      obj.options={}
      obj.options.audience_options = dataOptions.audience_options
      obj.options.media_rank_options = dataOptions.media_rank_options
      obj.ifShowViewed = this.changeBoolean(this.ifShowViewed)
      obj.bus_id_arr=[]
      for (let ele of obj.bus_line){
        obj.bus_id_arr.push(ele.bus_name)
      }
      obj.options.poi_ba_value_selection_list = dataInformation['poi_ba_value_selection_list']
      obj.options.poi_ba_label_selection_list = dataInformation['poi_ba_label_selection_list']
      obj.process_type = processType
      obj.discount_limit = this.discount_limit
      
      // 外部用户直接提交
      if (this.is_external_user) {
        let api_url = _global.serverSrc + '/add_process/?format=json'
        this.$axios.post(api_url, obj)
          .then(response => {
            if (response.data.upload_check && response.data.upload_check[0].is_ok == 1) {
              this.$message({
                message: this.$t('message.The_data_is_successfully_uploaded'),
                type: 'success'
              });
              this.processDialogVisible = false
              // 成功后清空数据
              this.clearData()
            } else {
              this.$message({
                message: this.$t('message.The_data_is_failed_to_upload'),
                type: 'error'
              });
              this.processDialogVisible = false
            }
          })
          .catch(e => {
            this.$message({
              message: this.$t('message.The_data_is_failed_to_upload'),
              type: 'error'
            });
          })
      } else {
        // 内部用户原有逻辑
        let api_url = _global.serverSrc + '/add_process/?format=json'
        this.$axios.post(api_url, obj)
          .then(response => {
            if(response.data.msg != undefined) {
              this.no_salesdirector = true
            }
            else if (response.data.upload_check[0].is_ok == 1) {
              this.$message({
                message: this.$t('message.The_data_is_successfully_uploaded'),
                type: 'success'
              });
              this.processDialogVisible = false
            } else {
              //失败了
              this.$message({
                message: this.$t('message.The_data_is_failed_to_upload'),
                type: 'error'
              });
              this.processDialogVisible = false
            }
          })
          .catch(e => {
          })
      }
    },

    getPricingInfo() {
      let dataMap = JSON.parse(sessionStorage.getItem('Data_Map'))
      let dataMapDetail = JSON.parse(sessionStorage.getItem('Data_Map_Detail'))
      if (dataMap) {
        //this.tableData = dataMap.tableData
        this.estimated_cost = dataMap.estimated_cost
        this.CPM = dataMap.CPM;
        this.adjusted_CPM = dataMap.adjusted_CPM;
        this.media_cost = dataMap.media_cost;
        this.production_cost = dataMap.production_cost;
        this.proposal_cost = dataMap.proposal_cost;

        this.media_CPM = dataMap.media_CPM;
        this.adjusted_media_CPM = dataMap.adjusted_media_CPM;
        this.proposal_CPM = dataMap.proposal_CPM;
        this.adjusted_proposal_CPM = dataMap.adjusted_proposal_CPM;

        this.discount_media_CPM = dataMap.discount_media_CPM
        this.discount_adjusted_media_CPM = dataMap.discount_adjusted_media_CPM
        this.discount_proposal_CPM = dataMap.discount_proposal_CPM
        this.discount_adjusted_proposal_CPM = dataMap.discount_adjusted_proposal_CPM

        this.media_discount = dataMap.media_discount
        this.proposal_discount = dataMap.proposal_discount
        this.production_discount = dataMap.production_discount

        this.media_discount_cost = dataMap.media_discount_cost
        this.production_discount_cost = dataMap.production_discount_cost
        this.proposal_discount_cost = dataMap.proposal_discount_cost
        
        //this.ifShowViewed = dataMap.ifShowViewed;
        this.pricingMode = dataMap.pricingMode

        /*
        dataNextDetail.multiple = this.multiple;
        dataNextDetail.busbody = this.busbody;
        dataNextDetail.media_formats = this.media_formats;
        dataNextDetail.multipleSelection = this.multipleSelection;
        */
        sessionStorage.removeItem('Data_Map')
        // 外部用户不显示折扣警告
        if (!this.is_external_user) {
          if (this.pricingMode == "media") {
            this.discount_warning = this.media_discount < this.discount_limit
          }
          else if (this.pricingMode == "proposal") {
            this.discount_warning = this.proposal_discount < this.discount_limit
          }
        } else {
          this.discount_warning = false
        }
      }
    },

    getDataInformation() {
      return JSON.parse(sessionStorage.getItem('Data_Information'));
    },

    refreshPanelButton(stat) {
      this.refreshPanel(stat);
    },
    selectAllLines() {
      // 全选所有线路，不受数量限制
      const selectedIds = this.multiple.originOptions.map(item => item.id);
      
      this.multiple.selectedList = selectedIds;
      this.checkboxGroup1 = selectedIds;
      
      // 同步初始化 busbody 和 media_formats
      this.busbody = selectedIds.map(() => "1");
      this.media_formats = selectedIds.map(() => this.mediaFormatsDefalutValue || 1);
    },

    refreshPanel(stat) {
      var _self = this;
      var total_objects = [
        {
          data_audience: _self.dataInfo.data_audience,
          start_date: _self.dataInfo.date,
          campaign_duration : _self.dataInfo.value_duration
        },
      ];
      if (stat == "created") {
        for (let ele in this.selectedOptions) {
          var obj = {
            bus_id: this.selectedOptions[ele].id,
            rate : this.selectedOptions[ele].rate,
            related_poi_nb : this.selectedOptions[ele].related_poi_nb,
            value_bus_num: Number(this.busbody[ele]),
            value_duration: this.dataInfo.value_duration,
            value_media_format: this.dataInfo.data_media_rank
              .value_media_format[0],
            hub_bus_id: this.selectedOptions[ele].hub_bus_id,
          };
          this.mediaFormatsDefalutValue = this.dataInfo.data_media_rank.value_media_format[0];
          this.media_formats.push(this.mediaFormatsDefalutValue);
          total_objects.push(obj);
        }
      } else if (stat == "edit") {
        this.$refs.multipleTable.toggleAllSelection();
        
        if (this.multipleSelection.length == 0) {
          this.multipleSelection = this.selectedOptions;
        }

        for (let ele in this.multipleSelection) {
          var obj = {
            bus_id: this.selectedOptions[ele].id,
            rate : this.selectedOptions[ele].rate,
            related_poi_nb : this.selectedOptions[ele].related_poi_nb,
            value_bus_num: Number(this.busbody[ele]),
            value_duration: this.dataInfo.value_duration,
            value_media_format: this.media_formats[ele],
            hub_bus_id: this.selectedOptions[ele].hub_bus_id,
          };
          /* this.mediaFormatsDefalutValue = this.dataInfo.data_media_rank.value_media_format[0]
            this.media_formats.push(this.mediaFormatsDefalutValue) */
          total_objects.push(obj);

          //有值的话，覆盖.
          /* let data_map_detail = JSON.parse(sessionStorage.getItem('Data_Map_Detail'));
            if (data_map_detail) {
              this.multiple = data_map_detail.multiple
              this.busbody = data_map_detail.busbody
              this.multipleSelection = data_map_detail.multipleSelection
              this.media_formats = data_map_detail.media_formats
            } */
        }
      } else {
        this.$refs.multipleTable.toggleAllSelection();
        if (this.multipleSelection.length == 0) {
          this.multipleSelection = this.selectedOptions;
        }
        for (let ele in this.multipleSelection) {
          var obj = {
            bus_id: this.selectedOptions[ele].id,
            rate : this.selectedOptions[ele].rate,
            related_poi_nb : this.selectedOptions[ele].related_poi_nb,
            value_bus_num: Number(this.busbody[ele]),
            value_duration: this.dataInfo.value_duration,
            value_media_format: this.media_formats[ele],
            hub_bus_id: this.selectedOptions[ele].hub_bus_id,
          };

          total_objects.push(obj);
        }

        let tmp = [];
        this.multipleSelection.forEach((obj) => {
          tmp.push(obj.id);
        });
        this.multiple.selectedList = tmp;
      }
      //是否能够显示viewed impressions (selected based)
      let poi_obj = _self.dataInfo.data_poi;
      let audience_obj = _self.dataInfo.data_audience;
      let flag_poi_obj = !(
        poi_obj.checked_business &
        poi_obj.checked_entertainment &
        poi_obj.checked_living &
        poi_obj.checked_trip
      );
      let flag_audience_obj =
        (audience_obj.value_gender == 0) &
        (audience_obj.value_interest == 0) &
        (audience_obj.value_age[0] == 0) &
        (audience_obj.value_spend_power[0] == 0);

      if (flag_poi_obj == true && flag_audience_obj == true) {
        this.ifShowViewed = false;
      }

      //发到后端进行计算 total的值。
      _self.getTotalValue(total_objects);
      var mapf = _self.$refs.mapf;
      mapf.clearMap();
      for (let ele in this.selectedOptions) {
        mapf.lineSearch(
          this.selectedOptions[ele].name ? this.selectedOptions[ele].name : this.selectedOptions[ele].id.replace("line_", "") + "路",
          this.chosen_city
        );
      }
      //全选情况下刷新是全选
      //按了一部分的情况下
      this.$refs.multipleTable.toggleAllSelection();

      _self.loading = false;

      //get poi location
      this.getSelectedPoiLocation(
        this.dataInfo.poi_ba_value_selection_list,
        mapf
      );
    },

    getTotalValue(total_objects) {
      let api_url = _global.serverSrc + "/bus_line_summary/?format=json&chosen_city=" + this.$route.query.chosen_city;

      this.total_objects = total_objects;
      sessionStorage.setItem("total_objects", JSON.stringify(total_objects));
      let obj = {
        'email': JSON.parse(sessionStorage.getItem('User')),
        'total_objects': total_objects
      }
      this.$axios
        .post(api_url, obj)
        .then((response) => {
          this.totalInfo = response.data.bus_line_summary;
          this.tableData[0].value = response.data.bus_line_summary[0].total_bus_lines; //total bus lines

          this.tableData[1].value = response.data.bus_line_summary[0].bus_body;
          this.tableData[2].value = response.data.bus_line_summary[0].duration; //total audience reach

          this.tableData[3].value = response.data.bus_line_summary[0].total_audience_reach; //total audience reach
          this.tableData[4].value = parseInt(
            response.data.bus_line_summary[0].total_audience_impressions
          ).toLocaleString(); //total audience impressions
          this.tableData[5].value = parseInt(
            response.data.bus_line_summary[0].total_solution_impressions
          ).toLocaleString(); //total audience impressions
          this.tableData[6].value = response.data.bus_line_summary[0].total_frequency_media; //total frequency media

          this.tableData[7].value = parseInt(response.data.bus_line_summary[0].distinct_audience).toLocaleString(); 
          this.tableData[8].value = parseFloat(response.data.bus_line_summary[0].one_month_frequency).toFixed(1).toLocaleString();
          this.tableData[9].value = parseFloat(response.data.bus_line_summary[0].distinct_audience*100/response.data.bus_line_summary[0].city_population).toFixed(1).toLocaleString(); 

          this.imp = response.data.bus_line_summary[0].total_audience_impressions
          this.target_imp = response.data.bus_line_summary[0].total_solution_impressions
          this.estimated_cost = parseInt(response.data.bus_line_summary[0].total_cost)//parseInt(response.data.bus_line_summary[0].estimated_cost).toLocaleString();
          this.media_cost = parseInt(response.data.bus_line_summary[0].media_cost).toLocaleString();
          this.production_cost = parseInt(response.data.bus_line_summary[0].production_cost).toLocaleString();
          this.proposal_cost = parseInt(response.data.bus_line_summary[0].total_cost).toLocaleString();
          this.media_discount_cost = parseInt(response.data.bus_line_summary[0].media_cost)
          this.production_discount_cost = parseInt(response.data.bus_line_summary[0].production_cost)
          this.proposal_discount_cost = parseInt(response.data.bus_line_summary[0].total_cost)
        
          this.CPM = response.data.bus_line_summary[0].CPM;
          this.adjusted_CPM = response.data.bus_line_summary[0].adjusted_CPM;
          this.media_CPM = response.data.bus_line_summary[0].media_CPM;
          this.adjusted_media_CPM = response.data.bus_line_summary[0].adjusted_media_CPM;
          this.proposal_CPM = response.data.bus_line_summary[0].proposal_CPM;
          this.adjusted_proposal_CPM = response.data.bus_line_summary[0].adjusted_proposal_CPM;

          this.media_discount = 100
          this.production_discount = 100
          this.proposal_discount = 100

          this.getPricingInfo()
        })
        .catch((e) => {
        });
    },

    busInfoTrans() {
      var _self = this;
      let api_url = _global.serverSrc + "/bus_line_summary_list/?format=json&chosen_city=" + this.$route.query.chosen_city;
      var bus_id_arr = [];
      var reach_arr = [];
      var frequency_arr = [];
      var impression_total_arr = [];
      var price_arr = [];
      var cpm_arr = [];
      let adjusted_impression_arr = [];
      let adjusted_cpm_arr = [];
      let obj = {
        'email': JSON.parse(sessionStorage.getItem('User')),
        'total_objects':  _self.total_objects,
      }
      this.$axios
        .post(api_url, obj)
        .then((response) => {
          // for (let i = 0; i < _self.selectedOptions.length; i++) {
          //   response.data.bus_line_summary_list[i].rate = _self.multipleSelection[i].rate;
          //   response.data.bus_line_summary_list[i].related_poi_nb =
          //     _self.multipleSelection[i].related_poi_nb;
          // }
          sessionStorage.setItem('tableDataCommercial',
            JSON.stringify(response.data.bus_line_summary_list)
          );
          for (let ele in response.data.bus_line_summary_list) {
            bus_id_arr.push(response.data.bus_line_summary_list[ele]["bus_name"]);
            reach_arr.push(response.data.bus_line_summary_list[ele]["reach"]);
            frequency_arr.push(response.data.bus_line_summary_list[ele]["frequency"]);
            impression_total_arr.push(response.data.bus_line_summary_list[ele]["impression_total"]);
            price_arr.push(response.data.bus_line_summary_list[ele]["price"]);
            cpm_arr.push(response.data.bus_line_summary_list[ele]["CPM"]);
            adjusted_impression_arr.push(
              response.data.bus_line_summary_list[ele]["adjusted_impression"]
            );
            adjusted_cpm_arr.push(response.data.bus_line_summary_list[ele]["adjusted_CPM"]);
          }
          sessionStorage.setItem('bus_id_arr', JSON.stringify(bus_id_arr));
          sessionStorage.setItem('reach_arr', JSON.stringify(reach_arr));
          sessionStorage.setItem(
            'frequency_arr',
            JSON.stringify(frequency_arr)
          );
          sessionStorage.setItem(
            'impression_total_arr',
            JSON.stringify(impression_total_arr)
          );
          sessionStorage.setItem('price_arr', JSON.stringify(price_arr));
          sessionStorage.setItem('cpm_arr', JSON.stringify(cpm_arr));
          sessionStorage.setItem(
            'adjusted_impression_arr',
            JSON.stringify(adjusted_impression_arr)
          );
          sessionStorage.setItem(
            'adjusted_cpm_arr',
            JSON.stringify(adjusted_cpm_arr)
          );
          _self.$router.push({
            path: "/board",
            query: {
              chosen_city: this.$route.query.chosen_city,
            },
          });
        })
        .catch((e) => {
        });
    },
    
    async busInfoTrans_2() {
      var _self = this;
      let api_url = _global.serverSrc + "/bus_line_summary_list/?format=json&chosen_city=" + this.$route.query.chosen_city;
      let obj = {
        'email': JSON.parse(sessionStorage.getItem('User')),
        'total_objects':  _self.total_objects,
      }
      await this.$axios
        .post(api_url, obj)
        .then((response) => {
          sessionStorage.setItem('tableDataCommercial',
            JSON.stringify(response.data.bus_line_summary_list)
          );
        })
        .catch((e) => {
        });
    },

    changeBoolean(data_poi){
      if (data_poi == false){
        data_poi = 0
      } else if (data_poi == true){
        data_poi =1
      }else{
        for (let ele in data_poi){
          if (data_poi[ele] == true){
            data_poi[ele] = 1
          }else{
            data_poi[ele] = 0
          }
        }
      }
      return data_poi
    },

    changeBooleanInverse(data_poi) {
      if (data_poi == 0) {
        data_poi = false;
      } else if (data_poi == 1) {
        data_poi = true;
      } else {
        for (let ele in data_poi) {
          if (data_poi[ele] == 1) {
            data_poi[ele] = true;
          } else {
            data_poi[ele] = false;
          }
        }
      }
      return data_poi;
    },

    async getBusLineData(stat) {
      let data = this.dataInfo;
      let api_url = _global.serverSrc + "/bus_line_rating/?format=json&chosen_city=" + this.$route.query.chosen_city;
      var _self = this;

      if (stat == "edit") {
        let dataHistory = JSON.parse(sessionStorage.getItem('Data_History'));
        let dataInfo = JSON.parse(sessionStorage.getItem('Data_Information'));

        dataInfo.poi_ba_value_selection_list =
          dataHistory.options.poi_ba_value_selection_list;
        dataInfo.poi_ba_label_selection_list =
          dataHistory.options.poi_ba_label_selection_list;
        this.dataInfo.poi_ba_value_selection_list =
          dataHistory.options.poi_ba_value_selection_list;
        this.dataInfo.poi_ba_label_selection_list =
          dataHistory.options.poi_ba_label_selection_list;
        sessionStorage.setItem(
          'Data_Information',
          JSON.stringify(this.dataInfo)
        );
        this.dataInfo = this.getDataInformation();
        this.dataInfo.date = new Date(this.dataInfo.date).toISOString();
        delete dataInfo.isEdit;
        let arr = [];
        Object.keys(dataInfo).forEach((v) => {
          let o = {};
          o[v] = dataInfo[v];
          arr.push(o);
        });
        this.multiple.selectedList = dataHistory.bus_id_arr;
        this.checkboxGroup1 = this.multiple.selectedList;
        let obj = {
          'email': JSON.parse(sessionStorage.getItem('User')),
          'dataInfo': arr
        }
        // add vendor dimension
        this.value_vendor = await this.getVendorList()

        obj['dataInfo'][2]['data_media_rank'].value_vendor=this.value_vendor

        this.$axios
          .post(api_url, obj)
          .then((response) => {
            _self.busLineRank = response.data.bus_line_rating;
            _self.queryData(response.data.bus_line_rating);

            _self.tableData = dataHistory.tableData;
            _self.estimated_cost = parseInt(dataHistory.estimated_cost).toLocaleString();
            _self.CPM = dataHistory.CPM;
            _self.adjusted_CPM = dataHistory.adjusted_CPM;

            //是否能够显示viewed impressions (selected based)
            let poi_obj = _self.dataInfo.data_poi;
            let audience_obj = _self.dataInfo.data_audience;
            let flag_poi_obj = !(
              poi_obj.checked_business &
              poi_obj.checked_entertainment &
              poi_obj.checked_living &
              poi_obj.checked_trip
            );
            let flag_audience_obj =
              (audience_obj.value_gender == 0) &
              (audience_obj.value_interest == 0) &
              (audience_obj.value_age[0] == 0) &
              (audience_obj.value_spend_power[0] == 0);

            if (flag_poi_obj == true && flag_audience_obj == true) {
              this.ifShowViewed = false;
            }

            _self.loading = false;
            _self.refreshPanel(stat);
          })
          .catch((e) => {
          });
      } else {
        delete data.media_format_options;
        delete data.isEdit;
        let arr = [];
        Object.keys(data).forEach((v) => {
          let o = {};
          o[v] = data[v];
          arr.push(o);
        });
        let obj = {
          'email': JSON.parse(sessionStorage.getItem('User')),
          'dataInfo': arr
        }
        this.$axios
          .post(api_url, obj)
          .then((response) => {
            _self.busLineRank = response.data.bus_line_rating;
            //sessionStorage.setItem('Bus_Line', JSON.stringify(response.data));
            _self.queryData(response.data.bus_line_rating);
            //print(response.data.bus_line_rating)

            /* if (stat == "edit"){
                let dataHistory = JSON.parse(sessionStorage.getItem('Data_History'))
                let arrTmp = []
                for (let ele of dataHistory.bus_line){
                  let tmp = ele.bus_id.replace(' ','_')
                  arrTmp.push(tmp)
                }
                _self.multiple.selectedList = arrTmp
              } */

            _self.refreshPanel(stat);
          })
          .catch((e) => {
          });
      }
    },
    async getVendorList(){
      let api_url = _global.serverSrc + "/vendor_info/?format=json&chosen_city=" + this.$route.query.chosen_city;
      let obj = {
          'email': JSON.parse(sessionStorage.getItem('User')),
          'date':this.value_date
        }
      const list_value_vendor = []
      await this.$axios
          .post(api_url, obj)
          .then((response) => {
            
            let vendor_info = response.data.vendor_info
            for (let i = 0; i < vendor_info.length; i++) {
              list_value_vendor[i] = vendor_info[i].code
            }

    })
    return list_value_vendor
  
  },

    getSelectedPoiLocation(poi_list, mapf) {
      let api_url = _global.serverSrc + "/selected_poi_location/?format=json&chosen_city=" + this.$route.query.chosen_city;
      let obj = {
        'email': JSON.parse(sessionStorage.getItem('User')),
        'poi_list': poi_list
      }
      this.$axios
        .post(api_url, obj)
        .then((response) => {
          mapf.drawPoi(response.data.selected_poi_location);
        })
        .catch((e) => {
        });
    },

    leftRight({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        return "font-weight:700";
      } else if (columnIndex === 1) {
        return "font-size:25px";
      }
    },

    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > this.offsetTop) {
        this.menuFixed = true;
      } else {
        this.menuFixed = false;
      }
    },

    intToString(number) {
      let result = "";
      number = number.toString();
      number = parseInt(number.replace(/,/g, ""));
      if (number < 1000) {
        result = number;
      } else if (number > 1000000000) {
        result =
          (number / 1000000000).toFixed(1).toString().replace(".0", "") + "B";
      } else if (number > 1000000) {
        result =
          (number / 1000000).toFixed(1).toString().replace(".0", "") + "M";
      } else {
        result = (number / 1000).toFixed(1).toString().replace(".0", "") + "K";
      }
      return result;
    },

    isEmpty(row) {
      return row.has_inventory && row.total_available_after_contract == 0;
    },

    isWarning(row) {
      return row.has_inventory && row.total_available_after_contract != 0 && row.total_available_after_contract/row.total<=(20/100);
    },

    isPriority(row) {
      return row.priority_to_sell || (row.has_inventory && row.total_available_after_contract/row.total>=(50/100));
    },

    tableRowClassName({row, rowIndex}) {
      //if(row.has_inventory && row.total_number - row.target_number <= this.busbody[rowIndex]) {
      if(row.has_inventory && row.total_available_after_contract <= this.busbody[rowIndex]) {
        return 'warning-row'; 
      }
      return '';
    },

    rowInventoryText(row) {
      //let rest = row.target_number //row.total_number - row.target_number
      let rest = row.hub_valid_bus_body
      if (this.$i18n.locale == 'cn') {
        if (!row.has_inventory)
          return '没有该线路的库存信息'
        else if (rest <= 5) {
          return '剩余 ' + rest + ' 台'
        }
        else {
          return '多于 5 台'
        }
      } else {
        if (!row.has_inventory)
          return 'No inventory info of this line'
        else if (rest <= 5) {
          return rest + ' remaining'
        }
        else {
          return 'More than 5 remaining'
        }
      }
    },
    rowInventoryTextByHub(row) {
      let rest = row.hub_valid_bus_body
      if (this.$i18n.locale == 'cn') {
        if (!row.has_inventory)
          return '没有该线路的库存信息'
        else{
          return '剩余 ' + parseInt(rest) + ' 台'
        } 
      }else {
        if (!row.has_inventory)
          return 'No inventory info of this line'
        else{
          return parseInt(rest) + ' remaining'
      }
  }},
    calculateMediaDiscount() {
      clearTimeout(this.timeoutId)
      this.timeoutId = setTimeout(()=> {
        this.media_discount = isNaN(Number(this.media_discount)) ? 0 : Number(this.media_discount)
        this.media_discount_cost = Number((this.media_discount * Number(this.media_cost.replaceAll(",","")) / 100).toFixed(0))
        this.production_discount = 100
        this.production_discount_cost = Number(this.production_cost.replaceAll(",",""))
        this.proposal_discount_cost = this.media_discount_cost + this.production_discount_cost
        this.proposal_discount = Number((this.proposal_discount_cost / Number(this.proposal_cost.replaceAll(",","")) * 100).toFixed(2))
        if (this.media_discount<this.discount_limit) {
          this.discount_warning = true
          document.querySelectorAll('.pricing').forEach(ele => {
            ele.getElementsByClassName('el-input__inner')[0].style.borderColor = 'red'
          })
        }
        else {
          this.discount_warning = false
          document.querySelectorAll('.pricing').forEach(ele => {
            ele.getElementsByClassName('el-input__inner')[0].style.borderColor = null
          })
        }
      }, 1000)

    },
    calculateMediaDiscountCost() {
      clearTimeout(this.timeoutId)
      this.timeoutId = setTimeout(()=> {
        this.media_discount_cost = isNaN(Number(this.media_discount_cost)) ? 0 : Number(this.media_discount_cost)
        let discount = (this.media_discount_cost /  Number(this.media_cost.replaceAll(",","")) * 100)
        this.media_discount = Number(discount.toFixed(2))
        this.production_discount = 100
        this.production_discount_cost = Number(this.production_cost.replaceAll(",",""))
        this.proposal_discount_cost = this.media_discount_cost + this.production_discount_cost
        this.proposal_discount = Number((this.proposal_discount_cost / Number(this.proposal_cost.replaceAll(",","")) * 100).toFixed(2))
        if (this.media_discount<this.discount_limit) {
          this.discount_warning = true
          document.querySelectorAll('.pricing').forEach(ele => {
            ele.getElementsByClassName('el-input__inner')[0].style.borderColor = 'red'
          })
        }
        else {
          this.discount_warning = false
          document.querySelectorAll('.pricing').forEach(ele => {
            ele.getElementsByClassName('el-input__inner')[0].style.borderColor = null
          })
        }
      }, 1000)

    },
    calculateTotalDiscount() {
      clearTimeout(this.timeoutId)
      this.timeoutId = setTimeout(()=> {
        this.proposal_discount = isNaN(Number(this.proposal_discount)) ? 0 : Number(this.proposal_discount)
        this.proposal_discount_cost = Number((this.proposal_discount * Number(this.proposal_cost.replaceAll(",","")) / 100).toFixed(0))
        this.media_discount = this.proposal_discount
        this.media_discount_cost = Number((this.media_discount * Number(this.media_cost.replaceAll(",","")) / 100).toFixed(0))
        this.production_discount = this.proposal_discount
        this.production_discount_cost = Number((this.production_discount * Number(this.production_cost.replaceAll(",","")) / 100).toFixed(0))
        if (this.proposal_discount<this.discount_limit) {
          this.discount_warning = true
          document.querySelectorAll('.pricing').forEach(ele => {
            ele.getElementsByClassName('el-input__inner')[0].style.borderColor = 'red'
          })
        }
        else {
          this.discount_warning = false
          document.querySelectorAll('.pricing').forEach(ele => {
            ele.getElementsByClassName('el-input__inner')[0].style.borderColor = null
          })
        }
      }, 1000)
    },
    calculateTotalDiscountCost() {
      clearTimeout(this.timeoutId)
      this.timeoutId = setTimeout(()=> {
        this.proposal_discount_cost = isNaN(Number(this.proposal_discount_cost)) ? 0 : Number(this.proposal_discount_cost)
        let discount = (this.proposal_discount_cost / Number(this.proposal_cost.replaceAll(",","")) * 100)
        this.proposal_discount = Number(discount.toFixed(2))
        this.media_discount = Number(discount.toFixed(2))
        this.media_discount_cost = Number((discount * Number(this.media_cost.replaceAll(",","")) / 100).toFixed(0))
        this.production_discount = Number(discount.toFixed(2))
        this.production_discount_cost = Number((discount * Number(this.production_cost.replaceAll(",","")) / 100).toFixed(0))
        if (this.proposal_discount<this.discount_limit) {
          this.discount_warning = true
          document.querySelectorAll('.pricing').forEach(ele => {
            ele.getElementsByClassName('el-input__inner')[0].style.borderColor = 'red'
          })
        }
        else {
          this.discount_warning = false
          document.querySelectorAll('.pricing').forEach(ele => {
            ele.getElementsByClassName('el-input__inner')[0].style.borderColor = null
          })
        }
      }, 1000)
    },

    changePricingMode() {
      //this.pricingMode = !this.pricingMode
      this.media_discount = 100
      this.media_discount_cost = Number(this.media_cost.replaceAll(",",""))
      this.production_discount = 100
      this.production_discount_cost = Number(this.production_cost.replaceAll(",",""))
      this.proposal_discount = 100
      this.proposal_discount_cost = Number(this.proposal_cost.replaceAll(",",""))
      this.discount_warning = false;
    },
    delcommafy(num) {
      if (num != '' && num !=null){
        num = num.replace(/,/g, '')
      }else{
        num = 0
      }
      return Number(num)
    },
    pricingDrawerOpened() {
      if (this.discount_warning)
        document.querySelectorAll('.pricing').forEach(ele => {
          ele.getElementsByClassName('el-input__inner')[0].style.borderColor = 'red'
        })
    },
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll); //监听滑动事件
    window.addEventListener('resize', this.handleResize);
  },
  components: {
    head_page,
    head_menu,
    multiple_choice_search,
    mapf,
    VGauge,
  },
};
</script>
<style lang="scss" scoped>
#top_board {
  margin-left: 20px;
  margin-top: 25px;
}

.level2_div_map {
  background-color: #f7f7f6;
  height: auto;
  margin-bottom: 0px;
}

#input-card {
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border-radius: 0.25rem;
  border-width: 0;
  border-radius: 0.4rem;
  box-shadow: 0 2px 6px 0 rgba(114, 124, 245, 0.5);
  position: fixed;
  bottom: 1rem;
  right: 1rem;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  padding: 0.75rem 1.25rem;
  position: relative;
  left: 80px;
  top: 20px;
  width: 18rem;
}

.my-autocomplete {
  li {
    line-height: normal;

    .name {
      text-overflow: ellipsis;
      overflow: hidden;
    }

    .addr {
      font-size: 12px;
      color: #b4b4b4;
    }

    .highlighted .addr {
      color: #ddd;
    }
  }
}

.isFixed {
  @media (max-width: 767px) {
    position: fixed;
    width: calc(100% - 40px);
    margin: 0 20px;
    top: 40px;
    left: 0;
    z-index: 999;
  }
}

.p-title-1 {
  font-size: 14px;
  color: #254a6e;
  font-weight: 600;
  -webkit-line-clamp: 2;
  white-space: pre-line;
}

.p-content-1 {
  font-size: 16px;
  color: #53adbc;
  font-weight: 600;
  -webkit-line-clamp: 2;
  white-space: pre-line;
}


.p-title-2 {
  font-size: 16px;
  color: #254a6e;
  font-weight: 600;
  -webkit-line-clamp: 2;
  white-space: pre-line;

  /deep/ .el-button.is-circle {
    padding: 5px
  }
}

.p-content-2{
  font-size: 22px;
  color: #53adbc;
  font-weight: 600;
  -webkit-line-clamp: 2;
  white-space: pre-line;
}


/deep/ .el-form-item__label {
  font-size: 12px;
  margin-bottom: 0;
  line-height: 20px;
  color: #254a6e;
}

/deep/ .el-form-item__content {
  text-align: left;
  font-size: 12px;
  line-height: 20px;
  margin-left: 10px;
  color: #53adbc;
}

/deep/ .el-form-item {
  margin-bottom: 0;
}

/deep/ .el-divider--horizontal {
  margin: 5px 0;
}

.refreshButton /deep/ .el-button {
  font-size: 12px;
  padding: 8px 14px 8px 14px;
}

/deep/ .el-popper {
  max-height: 210px;
}

/deep/ .el-scrollbar__wrap {
  max-height: 210px;
}

/deep/ .gauge-title {
  display: none;
}

.heatmapchart {
  min-height: 90px !important;
}

/deep/ .ion {
  display: inline-block;
  line-height: 1;
}

/deep/ label {
  margin-bottom: 0;
}

/deep/ .el-button.is-circle {
  padding: 7px;
}

/deep/ .warning-row {
  background: #dddddd;
  opacity: 0.5;
}

.pricing-row {
  line-height: 2.5;
  font-weight: normal;
}

.percentage-input {
  width: 80%;

  /deep/ .el-input__inner {
    text-align: right;
    color: #056C65;
  }
}

.price-input {
  width: 80%;

  /deep/ .el-input__inner {
    text-align: center;
    color: #056C65;
  }
}

/deep/ .el-drawer__header {
  margin-bottom: 15px;
}


</style>
